<template>
  <div class="jobs_wrapper">
    <div :class="{'overlay_setting': isLoadingData}">
      <i :class="{'loadding_setting': isLoadingData}"></i>
    </div>
    <div v-if="!isLoadingData">
      <div v-if="!isSearched">
        <h1 class="jobs_page_title_preview setting_word_break" v-bind:style="{ color: colorSetting.pageText }" v-if="jobSearchPageName">
          {{ jobSearchPageName }}
        </h1>
        <h1 class="jobs_page_title" v-bind:style="{ color: colorSetting.pageText }" v-else>
          {{ labelProperties.JOB_PAGE_TITLE }}
        </h1>
        <p class="jobs_table_annotation_preview setting_word_break" v-if="jobSearchPageOverview">{{ jobSearchPageOverview }}</p>
        <div class="jobs_table_wrapper">
          <template v-for="(category, cIndex) in categoriesJobSearch">
            <template v-if="category && !category.categoryDeleted && !isEmptyCategoryInJobSearch(cIndex)">
              <h2 class="jobs_category_title mt-3"
                  v-bind:style="{color: colorSetting.pageText, borderLeftColor: colorSetting.keyColor}">
                {{ category.categoryName }}
              </h2>
              <template v-for="(item, index) in category.item">
                <table class="jobs_table" v-bind:style="{ backgroundColor: colorSetting.pageBackground }">
                  <tbody class="jobs_table_body">
                    <tr class="jobs_table_rows" v-for="(subItem, indexItem) in filterResourceField(item.resourceField)" :key="indexItem">
                      <th class="jobs_table_head"
                          v-bind:style="[{ backgroundColor: colorSetting.subColor }, index === 0 ? { border: '1px solid' + colorSetting.borderColor } : {borderLeft: '1px solid' + colorSetting.borderColor, borderRight: '1px solid' + colorSetting.borderColor,  borderBottom: '1px solid' + colorSetting.borderColor}]">
                        <div class="jobs_table_head_holder">
                          <span class="jobs_table_label" v-bind:style="{ color: colorSetting.pageText }">
                            {{ item.itemName }}
                          </span>
                        </div>
                      </th>
                      <td class="jobs_table_cell"
                          v-bind:style="[index === 0 ? { border: '1px solid' + colorSetting.borderColor } : {borderLeft: '1px solid' + colorSetting.borderColor, borderRight: '1px solid' + colorSetting.borderColor, borderBottom: '1px solid' + colorSetting.borderColor}]">
                        <div class="jobs_table_form_rows">
                          <div class="jobs_table_form_item">
                            <InputComponent
                                class="mt-3"
                                :resource="subItem"
                                :indexResource="indexItem"
                                :master="getMasterData(subItem.master_name)"
                                :draftColors="colorSetting"
                                :itemJob="true"
                                :itemName="item.itemName"
                            />
                            <div v-if="item.viewAnnotation && item.annotationText" class="setting_word_break">
                              <span v-bind:style="{ color: colorSetting.pageText }">
                                ※{{ item.annotationText }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </template>
            </template>
          </template>
          <h2 class="jobs_category_title mt-3"
              v-bind:style="{color: colorSetting.pageText, borderLeftColor: colorSetting.keyColor}">
            {{ labelProperties.CATEGORY_FREE_WORD }}
          </h2>
          <table class="jobs_table">
            <tbody class="jobs_table_body">
              <tr class="jobs_table_rows">
                <th class="jobs_table_head"
                  v-bind:style="{borderTop: '1px solid' + colorSetting.borderColor, borderLeft: '1px solid' + colorSetting.borderColor, borderBottom: '1px solid' + colorSetting.borderColor, backgroundColor: colorSetting.subColor}">
                  <div class="jobs_table_head_holder">
                    <span class="jobs_table_label" v-bind:style="{ color: colorSetting.pageText }">
                      {{ labelProperties.FREE_WORD_SEARCH }}
                    </span>
                  </div>
                </th>
                <td class="jobs_table_cell"
                    v-bind:style="{borderTop: '1px solid' + colorSetting.borderColor, borderLeft: '1px solid' + colorSetting.borderColor, borderRight: '1px solid' + colorSetting.borderColor, borderBottom: '1px solid' + colorSetting.borderColor}">
                  <div class="jobs_table_form_rows">
                    <div class="jobs_table_form_item mt-3">
                      <input class="jobs_form_text" v-model="freeWord" type="text" :placeholder="labelProperties.PLACE_HOLDER_WORD_SEARCH"/>
                    </div>
                  </div>
                  <div class="jobs_table_form_rows">
                    <div class="jobs_table_form_item">
                      <div class="jobs_table_form_label_box">
                        <label class="setting_form_radio_label">
                          <input type="radio" v-model="condition" id="and" value="and"/>
                          <span v-bind:style="{ color: colorSetting.pageText }" for="and" class="setting_form_radio_text">
                            {{ labelProperties.AND }}
                          </span>
                        </label>
                        <label class="setting_form_radio_label">
                          <input type="radio" v-model="condition" id="or" value="or"/>
                          <span v-bind:style="{ color: colorSetting.pageText }" for="or" class="setting_form_radio_text">
                            {{ labelProperties.OR }}
                          </span>
                        </label>
                        <span class="ml-3 jobs_table_annotation" v-bind:style="{ color: colorSetting.pageText }">
                          {{ labelProperties.NOTICE_FREE_WORD }}
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="jobs_annotation_box">
            <p class="jobs_annotation_text">
              {{ labelProperties.NOTICE_CANT_SEARCH_COMBINATION }}
            </p>
          </div>
          <div class="jobs_btn_box">
            <button class="jobs_btn_primary mt-5" @click="searchJobDetail"
              v-bind:style="{color: colorSetting.mainButtonText, backgroundColor: colorSetting.mainButton, border: '1px solid' + colorSetting.borderColor}">
              <span v-if="button.searchBtn === ''">
                {{ labelProperties.CONFIRM_BUTTON }}
              </span>
              <span v-else>
                {{ button.searchBtn }}
              </span>
            </button>
          </div>
        </div>
      </div>

      <div v-else>
        <h1 class="jobs_page_title">
          {{ searchJobLabelsProperty.SEARCH_RESULT_LIST }}
        </h1>
        <h2 class="jobs_category_title">
          {{ searchJobLabelsProperty.CURRENT_SEARCH_CRITERIA }}
        </h2>
        <div :class="{'overlay_setting':isLoadingData} ">
          <i :class="{'loadding_setting': isLoadingData}"></i>
        </div>
        <div class="jobs_search_condition">
          <div class="jobs_search_condition_inner">
            <template v-if="!freeWord">
              <template v-for="category in categoriesJobSearch">
                <dl class="jobs_search_condition_list">
                  <template v-for="item in category.item">
                    <template v-if="!item.resourceField[0].isDeletedByMainSystem && item.resourceField[0].isHasValue">
                        <dt class="jobs_search_condition_label setting_word_break">
                          {{ item.itemName }}
                        </dt>
                       <dd class="jobs_search_condition_desc setting_word_break">
                          <span v-if="item.resourceField[0].default_value && (item.resourceField[0].type === 'text' || item.resourceField[0].type === 'textarea' || item.resourceField[0].type === 'url' || item.resourceField[0].type.includes('email')) || item.resourceField[0].type === 'tel' || item.resourceField[0].type === 'sequence'">
                            {{ item.resourceField[0].default_value }}
                          </span>
                          <span v-else-if="item.resourceField[0].default_value && TYPE_OF_MULTI_SELECT.includes(item.resourceField[0].type) && item.resourceField[0].default_value.length > 0">
                            {{ getValueCheckBox(item.resourceField[0].default_value) }}
                          </span>
                          <span v-else-if="item.resourceField[0].default_value !== null && TYPE_OF_SINGLE_SELECT.includes(item.resourceField[0].type)">
                          {{ getSingleSelect(item.resourceField[0]) }}
                        </span>
                          <span v-else-if="FORMAT_DATE.includes(item.resourceField[0].type)">
                            {{ getDatetimeString(item.resourceField[0].type, item.resourceField[0]) }}
                          </span>
                            <span v-else-if="!TYPE_OF_NUMBER.includes(item.resourceField[0].type) && (item.resourceField[0].default_value_from || item.resourceField[0].default_value_to)">
                            {{ item.resourceField[0].default_value_from }} ~ {{ item.resourceField[0].default_value_to }}
                        </span>
                        <span v-else-if="TYPE_OF_NUMBER.includes(item.resourceField[0].type) && (item.resourceField[0].default_value_from || item.resourceField[0].default_value_to)">
                          {{ formatNumberByStep(item.resourceField[0].default_value_from, item.resourceField[0].step) }} ~
                          {{ formatNumberByStep(item.resourceField[0].default_value_to, item.resourceField[0].step) }}
                        </span>
                        <span v-else> -- </span>
                        <span v-if="item.resourceField[0].unit" class="ml-1" :class="{'label_unit_item_long': item.resourceField[0].unit.length > userConfig.UNIT_LENGTH, 'label_unit_item': item.resourceField[0].unit.length <= userConfig.UNIT_LENGTH}">{{ item.resourceField[0].unit }}</span>
                      </dd>
                    </template>
                  </template>
                </dl>
              </template>
            </template>
            <div class="jobs_search_setting" v-if="freeWord">
              <dt class="jobs_search_condition_label setting_word_break">
                {{ searchJobLabelsProperty.FREE_WORD }}（
                <span style="text-transform: uppercase"> {{ condition }} </span>)
              </dt>
              <dd class="jobs_search_condition_desc setting_word_break">
                <span>
                  {{ freeWord }}
                </span>
              </dd>
            </div>
            <template v-if="!numberOfSearchByItem && !freeWord">
              <label>
                {{searchJobLabelsProperty.NONE}}
              </label>
            </template>
          </div>
          <div class="jobs_search_condition_btn">
            <button class="jobs_btn_secondary jobs_btn_medium"
              v-bind:style="{
                color: colorSetting.subButtonText,
                backgroundColor: colorSetting.subButton
              }"
              @click="returnJobSearchPage"
            >
              {{ searchJobLabelsProperty.BUTTON_CHANGE_CONDITON_SEARCH }}
            </button>
          </div>
        </div>
        <div class="jobs_search_result" v-if="totalResultSearchJob > 0">
          <span class="jobs_search_result_number">
            {{ totalResultSearchJob }}
          </span>
          <span class="jobs_search_result_unit">
            {{ searchJobLabelsProperty.IN_PIECE }}
          </span>
          <span class="jobs_search_result_range">
            {{ fromJob }} ～ {{ totalResultSearchJob > toJob ? toJob : totalResultSearchJob }} {{ searchJobLabelsProperty.SHOW_MATTER }}
          </span>
        </div>

        <div class="jobs_result">
          <ul class="jobs_result_list" v-for="(job, indexJobDetail) in jobViewDetails" :key="indexJobDetail">
            <li class="jobs_result_item" v-if="!job.flag">
              <div class="jobs_result_inner">
                <h2 class="jobs_result_heading">
                  <router-link @click.native="!jobNewWindow ? onTopOfIframe() : null" :target="jobNewWindow ? '_blank':''" v-bind:to="'/?c=' + encodeURIComponent(encryptJobCode) + '&jid=' + job.id + '&query=' + encodeURIComponent(keyRedisSearch) + `&jt=${DETAIL_FORM_TYPE}`">
                    <a class="jobs_result_title" v-bind:style="{ color: colorSetting.linkText }" style="text-decoration: none">
                      <template v-for="(headingSetting, index) in headingSettings">
                        <template v-if="job[headingSetting.name] && jobResourceFields[headingSetting.name]">
                          <span v-if="isPreviousItemHaveData(job, headingSetting.name, index, headingSettings[index ? index - 1: index].name, headingSettings)">
                            /
                          </span>
                          <span v-if="jobResourceFields[headingSetting.name].name === 'company_id'">
                            <span v-if="job[companyPublicSetting] === 1">
                              <span v-if="getCompanyNameByCompanyId(job.company_id)">
                                {{ getCompanyNameByCompanyId(job.company_id) }}
                              </span>
                              <span v-else>
                                {{ searchJobLabelsProperty.NAME_COMPANY_UNREGISTER }}
                              </span>
                            </span>
                            <span v-else>
                              {{ searchJobLabelsProperty.NAME_COMPANY_PRIVATE }}
                            </span>
                          </span>
                          <span v-else-if="jobResourceFields[headingSetting.name].name === 'staff_id'">
                            {{ getStaffNameByStaffId(job.staff_id) }}
                          </span>
                          <span v-else-if="jobResourceFields[headingSetting.name].type === 'free_email' && job[headingSetting.name].data" >
                            {{ job[headingSetting.name].data }}
                          </span>
                          <span v-else-if="jobResourceFields[headingSetting.name].type === 'url'" >
                            {{ job[headingSetting.name] }}
                          </span>
                          <span v-else-if="TYPE_OF_SINGLE_SELECT.includes(jobResourceFields[headingSetting.name].type) && jobResourceFields[headingSetting.name].master_name && jobResourceFields[headingSetting.name].name">
                            {{ getSingleSelectValue(jobResourceFields[headingSetting.name].master_name, job[headingSetting.name]) }}
                          </span>
                          <span v-else-if="TYPE_OF_MULTI_SELECT.includes(jobResourceFields[headingSetting.name].type) && jobResourceFields[headingSetting.name].master_name && jobResourceFields[headingSetting.name].name">
                            <span v-for="(value, index) in getMultiSelectValue(jobResourceFields[headingSetting.name].master_name, job[headingSetting.name])" :key="index">
                              <span v-if="index !== 0">, </span>
                              <span>{{ value }}</span>
                            </span>
                          </span>
                          <span v-else-if="FORMAT_DATE.includes(jobResourceFields[headingSetting.name].type)">
                            {{ getDatetimeString(jobResourceFields[headingSetting.name].type, job[headingSetting.name]) }}
                          </span>
                          <span v-else-if="TYPE_OF_NUMBER.includes(jobResourceFields[headingSetting.name].type)">
                            {{formatNumberByStep(job[headingSetting.name], jobResourceFields[headingSetting.name].step)}}
                          </span>
                          <span v-else>
                            {{ job[headingSetting.name] }}
                          </span>
                          <span v-if="jobResourceFields[headingSetting.name].unit" class="ml-1" :class="{'label_unit_item_long': jobResourceFields[headingSetting.name].unit.length > userConfig.UNIT_LENGTH, 'label_unit_item': jobResourceFields[headingSetting.name].unit.length <= userConfig.UNIT_LENGTH}">{{ jobResourceFields[headingSetting.name].unit }}</span>
                        </template>
                      </template>
                    </a>
                  </router-link>
                </h2>
                <div class="jobs_result_text" v-for="(bodySetting, index) in bodySettings" :key="index">
                  <template v-if="job[bodySetting.name] && jobResourceFields[bodySetting.name]">
                    <span v-if="jobResourceFields[bodySetting.name].name === 'company_id'">
                      <span v-if="job[companyPublicSetting] === 1">
                        <span v-if="getCompanyNameByCompanyId(job.company_id)">
                          {{ getCompanyNameByCompanyId(job.company_id) }}
                        </span>
                        <span v-else>
                          {{ searchJobLabelsProperty.NAME_COMPANY_UNREGISTER }}
                        </span>
                      </span>
                      <span v-else>
                        {{ searchJobLabelsProperty.NAME_COMPANY_PRIVATE }}
                      </span>
                    </span>
                    <span v-else-if="jobResourceFields[bodySetting.name].name === 'staff_id'">
                      {{ getStaffNameByStaffId(job.staff_id) }}
                    </span>
                    <span v-else-if="jobResourceFields[bodySetting.name].type === 'free_email' && job[bodySetting.name].data">
                      <a v-bind:style="{ color: colorSetting.linkText }"  :href="'mailto:' + job[bodySetting.name].data">
                        {{ job[bodySetting.name].data }}
                      </a>
                    </span>
                    <span v-else-if="jobResourceFields[bodySetting.name].type === 'url'">
                      <a v-bind:style="{ color: colorSetting.linkText }" :href="job[bodySetting.name]" style="text-decoration: none" target="_blank">
                        {{ job[bodySetting.name] }}
                      </a>
                    </span>
                    <span v-else-if="TYPE_OF_SINGLE_SELECT.includes(jobResourceFields[bodySetting.name].type) && jobResourceFields[bodySetting.name].master_name && jobResourceFields[bodySetting.name].name">
                      {{ getSingleSelectValue(jobResourceFields[bodySetting.name].master_name, job[bodySetting.name]) }}
                    </span>
                    <span v-else-if="TYPE_OF_MULTI_SELECT.includes(jobResourceFields[bodySetting.name].type) && jobResourceFields[bodySetting.name].master_name && jobResourceFields[bodySetting.name].name">
                      <span v-for="(value, index) in getMultiSelectValue(jobResourceFields[bodySetting.name].master_name, job[bodySetting.name])" :key="index">
                        <span v-if="index !== 0">, </span>
                        <span>{{ value }}</span>
                      </span>
                    </span>
                    <span v-else-if="FORMAT_DATE.includes(jobResourceFields[bodySetting.name].type)">
                      {{ getDatetimeString(jobResourceFields[bodySetting.name].type, job[bodySetting.name]) }}
                    </span>
                    <span v-else-if="TYPE_OF_NUMBER.includes(jobResourceFields[bodySetting.name].type)">
                      {{formatNumberByStep(job[bodySetting.name], jobResourceFields[bodySetting.name].step)}}
                    </span>
                    <span class="pre-margin-bottom line_break_setting_text" v-else>{{ job[bodySetting.name] }}</span>
                    <span v-if="jobResourceFields[bodySetting.name].unit" class="ml-1" :class="{'label_unit_item_long': jobResourceFields[bodySetting.name].unit.length > userConfig.UNIT_LENGTH, 'label_unit_item': jobResourceFields[bodySetting.name].unit.length <= userConfig.UNIT_LENGTH}">{{ jobResourceFields[bodySetting.name].unit }}</span>
                  </template>
                </div>
                <template v-for="(category, cIndex) in categoriesJobList">
                  <template v-if="category && !category.categoryDeleted && !isEmptyCategory(cIndex, indexJobDetail, job.flag)">
                    <h2 class="jobs_category_title mt-3"
                        v-bind:style="{color: colorSetting.pageText, borderLeftColor: colorSetting.keyColor}">
                      {{ category.categoryName }}
                    </h2>
                    <table class="jobs_detail_table">
                      <tbody class="jobs_detail_table_body">
                        <template v-for="(item, index) in category.item.filter(item => !item.resourceField[0].isDeletedByMainSystem)">
                          <tr class="jobs_detail_table_rows" v-if="!item.resourceField[0].name.startsWith(jobSettingProperty.ITEM_COMPANY_MODIFY) && job[item.resourceField[0].name] && ((item.resourceField[0].name === 'company_id' && job[companyPublicSetting] === 1) && getCompanyNameByCompanyId(job.company_id) || item.resourceField[0].name !== 'company_id')"
                              v-bind:key="item.resourceField[0].name">
                            <th class="jobs_detail_table_head"
                                v-bind:style="[{ backgroundColor: colorSetting.subColor }, index === 0 ? { border: '1px solid' + colorSetting.borderColor } : {borderLeft: '1px solid' + colorSetting.borderColor, borderRight: '1px solid' + colorSetting.borderColor, borderBottom: '1px solid' + colorSetting.borderColor}]">
                              <span v-bind:style="{ color: colorSetting.pageText }" class="setting_word_break">
                                {{ item.itemName }}
                              </span>
                            </th>
                            <td class="jobs_detail_table_cell word-break" v-bind:style="{borderTop: '1px solid' + colorSetting.borderColor, borderRight: '1px solid' + colorSetting.borderColor, borderBottom: '1px solid' + colorSetting.borderColor}">
                              <span v-if="item.resourceField[0].name === 'company_id'">
                                {{ getCompanyNameByCompanyId(job.company_id) }}
                              </span>
                              <span v-else-if="item.resourceField[0].type === 'free_email' && job[item.resourceField[0].name].data">
                                <a v-bind:style="{ color: colorSetting.linkText }" :href="'mailto:' + job[item.resourceField[0].name].data">
                                  {{ job[item.resourceField[0].name].data }}
                                </a>
                              </span>
                              <span v-else-if="item.resourceField[0].type === 'url'">
                                <a v-bind:style="{ color: colorSetting.linkText }" :href="job[item.resourceField[0].name]" target="_blank">
                                  {{ job[item.resourceField[0].name] }}
                                </a>
                              </span>
                              <span v-else-if="TYPE_OF_SINGLE_SELECT.includes(item.resourceField[0].type) && item.resourceField[0].master_name && item.resourceField[0].name">
                                {{ getSingleSelectValue(item.resourceField[0].master_name, job[item.resourceField[0].name]) }}
                              </span>
                              <span v-else-if="TYPE_OF_MULTI_SELECT.includes(item.resourceField[0].type) && item.resourceField[0].master_name && item.resourceField[0].name">
                                <span v-for="(value, index) in getMultiSelectValue(item.resourceField[0].master_name, job[item.resourceField[0].name])" :key="index">
                                  <span v-if="index !== 0">, </span>
                                  <span>{{ value }}</span>
                                </span>
                              </span>
                              <span v-else-if="FORMAT_DATE.includes(item.resourceField[0].type)">
                                {{ getDatetimeString(item.resourceField[0].type, job[item.resourceField[0].name]) }}
                              </span>
                              <span class="white-space" v-else-if="item.resourceField[0].type === 'textarea'">{{ job[item.resourceField[0].name] }}</span>
                              <span v-else-if="item.resourceField[0].name === 'staff_id'">
                                {{ getStaffNameByStaffId(job.staff_id) }}
                              </span>
                              <span v-else-if="TYPE_OF_NUMBER.includes(item.resourceField[0].type)">
                                {{formatNumberByStep(job[item.resourceField[0].name], item.resourceField[0].step)}}
                              </span>
                              <span v-else>{{ job[item.resourceField[0].name] }}</span>
                              <span v-if="item.resourceField[0].unit" class="ml-1" :class="{'label_unit_item_long': item.resourceField[0].unit.length > userConfig.UNIT_LENGTH, 'label_unit_item': item.resourceField[0].unit.length <= userConfig.UNIT_LENGTH}">{{ item.resourceField[0].unit }}</span>
                            </td>
                          </tr>
                          <tr :set="companyData = getCompanyByCompanyId(job.company_id)" class="jobs_detail_table_rows" v-if="item.resourceField[0].name.startsWith(jobSettingProperty.ITEM_COMPANY_MODIFY) && getCompanyByCompanyId(job.company_id)[item.resourceField[0].name.substring(8)] && job[companyPublicSetting] === 1"
                              v-bind:key="item.resourceField[0].name">
                            <th class="jobs_detail_table_head"
                                v-bind:style="[{ backgroundColor: colorSetting.subColor }, index === 0 ? { border: '1px solid' + colorSetting.borderColor } : {borderLeft: '1px solid' + colorSetting.borderColor, borderRight: '1px solid' + colorSetting.borderColor, borderBottom: '1px solid' + colorSetting.borderColor}]">
                              <span v-bind:style="{ color: colorSetting.pageText }" class="setting_word_break">
                                {{ item.itemName }}
                              </span>
                            </th>
                            <td class="jobs_detail_table_cell word-break" v-bind:style="{borderTop: '1px solid' + colorSetting.borderColor, borderRight: '1px solid' + colorSetting.borderColor, borderBottom: '1px solid' + colorSetting.borderColor}">
                              <span v-if="item.resourceField[0].type === 'free_email'">
                                <a v-bind:style="{ color: colorSetting.linkText }" :href="'mailto:' + companyData[item.resourceField[0].name.substring(8)]">
                                  {{ companyData[item.resourceField[0].name.substring(8)] }}
                                </a>
                              </span>
                              <span v-else-if="item.resourceField[0].type === 'url'">
                                <a v-bind:style="{ color: colorSetting.linkText }" :href="companyData[item.resourceField[0].name.substring(8)]" target="_blank">
                                  {{ companyData[item.resourceField[0].name.substring(8)] }}
                                </a>
                              </span>
                              <span v-else-if="TYPE_OF_SINGLE_SELECT.includes(item.resourceField[0].type) && item.resourceField[0].master_name && item.resourceField[0].name">
                                {{ getSingleSelectValue(item.resourceField[0].master_name, companyData[item.resourceField[0].name.substring(8)]) }}
                              </span>
                              <span v-else-if="TYPE_OF_MULTI_SELECT.includes(item.resourceField[0].type) && item.resourceField[0].master_name && item.resourceField[0].name">
                                <span v-for="(value, index) in getMultiSelectValue(item.resourceField[0].master_name, companyData[item.resourceField[0].name.substring(8)])" :key="index">
                                  <span v-if="index !== 0">, </span>
                                  <span>{{ value }}</span>
                                </span>
                              </span>
                              <span v-else-if="FORMAT_DATE.includes(item.resourceField[0].type)">
                                {{ getDatetimeString(item.resourceField[0].type, companyData[item.resourceField[0].name.substring(8)]) }}
                              </span>
                              <span class="white-space" v-else-if="item.resourceField[0].type === 'textarea'">{{ companyData[item.resourceField[0].name.substring(8)] }}</span>
                              <span v-else-if="TYPE_OF_NUMBER.includes(item.resourceField[0].type)">
                                {{formatNumberByStep(companyData[item.resourceField[0].name.substring(8)], item.resourceField[0].step)}}
                              </span>
                              <span v-else-if="isObjectDataHasValue(companyData[item.resourceField[0].name.substring(8)])">{{ companyData[item.resourceField[0].name.substring(8)].data }}</span>
                              <span v-else>{{ companyData[item.resourceField[0].name.substring(8)] }}</span>
                              <span v-if="item.resourceField[0].unit" class="ml-1" :class="{'label_unit_item_long': item.resourceField[0].unit.length > userConfig.UNIT_LENGTH, 'label_unit_item': item.resourceField[0].unit.length <= userConfig.UNIT_LENGTH}">{{ item.resourceField[0].unit }}</span>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </template>
                </template>
              </div>
              <div class="jobs_result_btn">
                <button class="jobs_btn_primary"
                  v-bind:style="{
                    color: colorSetting.mainButtonText,
                    backgroundColor: colorSetting.mainButton
                  }"
                  @click="viewDetailJob(job.id, DETAIL_FORM_TYPE)">
                  <span v-if="button.listBtn === ''">
                    {{ searchJobLabelsProperty.VIEW_DETAIL_JOB }}
                  </span>
                  <span v-else>
                    {{ button.listBtn }}
                  </span>
                </button>
              </div>
            </li>

            <li class="jobs_result_item" v-else>
              <div class="jobs_result_inner">
                <h2 class="jobs_result_heading">
                  <router-link @click.native="!jobNewWindow ? onTopOfIframe() : null" :target="jobNewWindow ? '_blank':''" v-bind:to="'/?c=' + encodeURIComponent(encryptJobCode) + '&jid=' + job.id + '&query=' + encodeURIComponent(keyRedisSearch) + `&jt=${DISPATCH_DETAIL_FORM_TYPE}`">
                    <a class="jobs_result_title" v-bind:style="{ color: colorSetting.linkText }" style="text-decoration: none">
                      <template v-for="(headingSetting, index) in headingDispatchJobSettings">
                        <template v-if="getSubItemValue(job, headingSetting.name) && getDispatchResourceType(headingSetting.name)">
                          <span :set="item = {typeOfItem: getDispatchResourceType(headingSetting.name), itemValue: getSubItemValue(job, headingSetting.name)}" :key="'list_heading_dp' + index">
                            <span v-if="isPreviousItemHaveData(job, headingSetting.name, index, headingDispatchJobSettings[index ? index - 1: index].name, headingDispatchJobSettings)">
                              /
                            </span>
                            <span v-if="item.typeOfItem.name === 'company_id'">
                              <span v-if="job[companyDispatchPublicSetting] === 1">
                                <span v-if="getCompanyNameByCompanyId(job.company_id)">
                                  {{ getCompanyNameByCompanyId(job.company_id) }}
                                </span>
                                <span v-else>
                                  {{ searchJobLabelsProperty.NAME_COMPANY_UNREGISTER }}
                                </span>
                              </span>
                              <span v-else>
                                {{ searchJobLabelsProperty.NAME_COMPANY_PRIVATE }}
                              </span>
                            </span>
                            <span v-else-if="item.typeOfItem.name === 'staff_id'">
                              {{ getStaffNameByStaffId(job.staff_id) }}
                            </span>
                            <span v-else-if="item.typeOfItem.type === 'free_email'">
                                {{ item.itemValue }}
                            </span>
                            <span v-else-if="item.typeOfItem.type === 'url'">
                                {{ item.itemValue }}
                            </span>
                            <span v-else-if="checkHaveMasterData(headingSetting.name) && TYPE_OF_SINGLE_SELECT.includes(item.typeOfItem.type) && item.typeOfItem.master_name && item.typeOfItem.name">
                              {{ getSingleSelectValue(item.typeOfItem.master_name, item.itemValue) }}
                            </span>
                            <span v-else-if="checkHaveMasterData(headingSetting.name) && TYPE_OF_MULTI_SELECT.includes(item.typeOfItem.type) && item.typeOfItem.master_name && item.typeOfItem.name">
                              <span v-for="(value, index) in getMultiSelectValue(item.typeOfItem.master_name, item.itemValue)" :key="index">
                                <span v-if="index !== 0">, </span>
                                <span>{{ value }}</span>
                              </span>
                            </span>
                            <span v-else-if="!checkHaveMasterData(headingSetting.name) && TYPE_OF_SINGLE_SELECT.includes(item.typeOfItem.type)">
                              {{ getValueFromApiMaster(job, headingSetting.name) }}
                            </span>
                            <span v-else-if="!checkHaveMasterData(headingSetting.name) && TYPE_OF_MULTI_SELECT.includes(item.typeOfItem.type)">
                              <span v-for="(value, index) in getValueFromApiMaster(job, headingSetting.name)" :key="index">
                                <span v-if="index !== 0">, </span>
                                <span>{{ value }}</span>
                              </span>
                            </span>
                            <span v-else-if="FORMAT_DATE.includes(item.typeOfItem.type)">
                              {{ getDatetimeString(item.typeOfItem.type, item.itemValue) }}
                            </span>
                            <span v-else-if="TYPE_OF_NUMBER.includes(item.typeOfItem.type)">
                              {{formatNumberByStep(item.itemValue, item.typeOfItem.step)}}
                            </span>
                            <span v-else>
                              {{ item.itemValue }}
                            </span>
                            <span v-if="item.typeOfItem.unit" class="ml-1" :class="{'label_unit_item_long': item.typeOfItem.unit.length > userConfig.UNIT_LENGTH, 'label_unit_item': item.typeOfItem.unit.length <= userConfig.UNIT_LENGTH}">{{ item.typeOfItem.unit }}</span>
                          </span>
                        </template>
                      </template>
                    </a>
                  </router-link>
                </h2>
                <div class="jobs_result_text" v-for="(bodySetting, index) in bodyDispatchJobSettings" :key="index">
                  <template v-if="getDispatchResourceType(bodySetting.name) && getSubItemValue(job, bodySetting.name)">
                    <div :set="item = {typeOfItem: getDispatchResourceType(bodySetting.name), itemValue: getSubItemValue(job, bodySetting.name)}">
                      <span v-if="item.typeOfItem.name === 'company_id'">
                        <span v-if="job[companyDispatchPublicSetting] === 1">
                          <span v-if="getCompanyNameByCompanyId(job.company_id)">
                            {{ getCompanyNameByCompanyId(job.company_id) }}
                          </span>
                          <span v-else>
                            {{ searchJobLabelsProperty.NAME_COMPANY_UNREGISTER }}
                          </span>
                        </span>
                        <span v-else>
                          {{ searchJobLabelsProperty.NAME_COMPANY_PRIVATE }}
                        </span>
                      </span>
                      <span v-else-if="item.typeOfItem.name === 'staff_id'">
                        {{ getStaffNameByStaffId(job.staff_id) }}
                      </span>
                      <span v-else-if="item.typeOfItem.type === 'free_email'">
                        <a v-bind:style="{ color: colorSetting.linkText }" :href="'mailto:' + item.itemValue">
                          {{ item.itemValue }}
                        </a>
                      </span>
                      <span v-else-if="item.typeOfItem.type === 'url'">
                        <a v-bind:style="{ color: colorSetting.linkText }" :href="item.itemValue" style="text-decoration: none" target="_blank">
                          {{ item.itemValue }}
                        </a>
                      </span>
                      <span v-else-if="checkHaveMasterData(bodySetting.name) && TYPE_OF_SINGLE_SELECT.includes(item.typeOfItem.type) && item.typeOfItem.master_name && item.typeOfItem.name">
                        {{ getSingleSelectValue(item.typeOfItem.master_name, item.itemValue) }}
                      </span>
                      <span v-else-if="checkHaveMasterData(bodySetting.name) && TYPE_OF_MULTI_SELECT.includes(item.typeOfItem.type) && item.typeOfItem.master_name && item.typeOfItem.name">
                        <span v-for="(value, index) in getMultiSelectValue(item.typeOfItem.master_name, item.itemValue)" :key="index">
                          <span v-if="index !== 0">, </span>
                          <span>{{ value }}</span>
                        </span>
                      </span>
                      <span v-else-if="!checkHaveMasterData(bodySetting.name) && TYPE_OF_SINGLE_SELECT.includes(item.typeOfItem.type)">
                        {{ getValueFromApiMaster(job, bodySetting.name) }}
                      </span>
                      <span v-else-if="!checkHaveMasterData(bodySetting.name) && TYPE_OF_MULTI_SELECT.includes(item.typeOfItem.type)">
                        <span v-for="(value, index) in getValueFromApiMaster(job, bodySetting.name)" :key="index">
                          <span v-if="index !== 0">, </span>
                          <span>{{ value }}</span>
                        </span>
                      </span>
                      <span v-else-if="FORMAT_DATE.includes(item.typeOfItem.type)">
                        {{ getDatetimeString(item.typeOfItem.type, item.itemValue) }}
                      </span>
                      <span v-else-if="TYPE_OF_NUMBER.includes(item.typeOfItem.type)">
                        {{formatNumberByStep(item.itemValue, item.typeOfItem.step)}}
                      </span>
                      <span class="pre-margin-bottom line_break_setting_text" v-else>{{ item.itemValue }}</span>
                      <span v-if="item.typeOfItem.unit" class="ml-1" :class="{'label_unit_item_long': item.typeOfItem.unit.length > userConfig.UNIT_LENGTH, 'label_unit_item': item.typeOfItem.unit.length <= userConfig.UNIT_LENGTH}">{{ item.typeOfItem.unit }}</span>
                    </div>
                  </template>
                </div>
                <template v-for="(category, cIndex) in categoriesDispatchJobList">
                  <template v-if="category && !category.categoryDeleted && !isEmptyCategory(cIndex, indexJobDetail, job.flag)">
                    <h2 class="jobs_category_title mt-3" :key="'cate_name' + cIndex"
                        v-bind:style="{color: colorSetting.pageText, borderLeftColor: colorSetting.keyColor}">
                      {{ category.categoryName }}
                    </h2>
                    <table class="jobs_detail_table" :key="'item_by_cate' + cIndex">
                      <tbody class="jobs_detail_table_body">
                        <template v-for="(item, index) in category.item.filter(item => !item.resourceField[0].isDeletedByMainSystem)">
                          <tr :set="itemSetting = {typeOfItem: getDispatchResourceType(item.resourceField[0].name), itemValue: getSubItemValue(job, item.resourceField[0].name)}" class="jobs_detail_table_rows" v-if="!item.resourceField[0].name.startsWith(jobSettingProperty.ITEM_COMPANY_MODIFY) && getSubItemValue(job, item.resourceField[0].name) && ((item.resourceField[0].name === 'company_id' && job[companyDispatchPublicSetting] === 1) && getCompanyNameByCompanyId(job.company_id) || item.resourceField[0].name !== 'company_id')"
                              v-bind:key="item.resourceField[0].name">
                            <th class="jobs_detail_table_head"
                                v-bind:style="[{ backgroundColor: colorSetting.subColor }, index === 0 ? { border: '1px solid' + colorSetting.borderColor } : {borderLeft: '1px solid' + colorSetting.borderColor, borderRight: '1px solid' + colorSetting.borderColor, borderBottom: '1px solid' + colorSetting.borderColor}]">
                              <span v-bind:style="{ color: colorSetting.pageText }" class="setting_word_break">
                                {{ item.itemName }}
                              </span>
                            </th>
                            <td class="jobs_detail_table_cell word-break" v-bind:style="{borderTop: '1px solid' + colorSetting.borderColor, borderRight: '1px solid' + colorSetting.borderColor, borderBottom: '1px solid' + colorSetting.borderColor}">
                              <span v-if="itemSetting.typeOfItem.name === 'company_id'">
                                {{ getCompanyNameByCompanyId(job.company_id) }}
                              </span>
                              <span v-else-if="itemSetting.typeOfItem.type === 'free_email'">
                                <a v-bind:style="{ color: colorSetting.linkText }" :href="'mailto:' + itemSetting.itemValue">
                                  {{ itemSetting.itemValue }}
                                </a>
                              </span>
                              <span v-else-if="itemSetting.typeOfItem.type === 'url'">
                                <a v-bind:style="{ color: colorSetting.linkText }" :href="itemSetting.itemValue" target="_blank">
                                  {{ itemSetting.itemValue }}
                                </a>
                              </span>
                              <span v-else-if="checkHaveMasterData(item.resourceField[0].name) && TYPE_OF_SINGLE_SELECT.includes(itemSetting.typeOfItem.type) && itemSetting.typeOfItem.master_name && item.resourceField[0].name">
                                {{ getSingleSelectValue(itemSetting.typeOfItem.master_name, itemSetting.itemValue) }}
                              </span>
                              <span v-else-if="checkHaveMasterData(item.resourceField[0].name) && TYPE_OF_MULTI_SELECT.includes(itemSetting.typeOfItem.type) && itemSetting.typeOfItem.master_name && item.resourceField[0].name">
                                <span v-for="(value, index) in getMultiSelectValue(itemSetting.typeOfItem.master_name, itemSetting.itemValue)" :key="index">
                                  <span v-if="index !== 0">, </span>
                                  <span>{{ value }}</span>
                                </span>
                              </span>
                              <span v-else-if="!checkHaveMasterData(item.resourceField[0].name) && TYPE_OF_SINGLE_SELECT.includes(itemSetting.typeOfItem.type)">
                                {{ getValueFromApiMaster(job, item.resourceField[0].name) }}
                              </span>
                              <span v-else-if="!checkHaveMasterData(item.resourceField[0].name) && TYPE_OF_MULTI_SELECT.includes(itemSetting.typeOfItem.type)">
                                <span v-for="(value, index) in getValueFromApiMaster(job, item.resourceField[0].name)" :key="index">
                                  <span v-if="index !== 0">, </span>
                                  <span>{{ value }}</span>
                                </span>
                              </span>
                              <span v-else-if="FORMAT_DATE.includes(itemSetting.typeOfItem.type)">
                                {{ getDatetimeString(itemSetting.typeOfItem.type, itemSetting.itemValue) }}
                              </span>
                              <span class="white-space" v-else-if="itemSetting.typeOfItem.type === 'textarea'">{{ itemSetting.itemValue }}</span>
                              <span v-else-if="itemSetting.typeOfItem.name === 'staff_id'">
                                {{ getStaffNameByStaffId(job.staff_id) }}
                              </span>
                              <span v-else-if="TYPE_OF_NUMBER.includes(itemSetting.typeOfItem.type)">
                                {{formatNumberByStep(itemSetting.itemValue, itemSetting.typeOfItem.step)}}
                              </span>
                              <span v-else>{{ itemSetting.itemValue }}</span>
                              <span v-if="itemSetting.typeOfItem.unit" class="ml-1" :class="{'label_unit_item_long': itemSetting.typeOfItem.unit.length > userConfig.UNIT_LENGTH, 'label_unit_item': itemSetting.typeOfItem.unit.length <= userConfig.UNIT_LENGTH}">{{ itemSetting.typeOfItem.unit }}</span>
                            </td>
                          </tr>
                          <tr :set="companyData = getCompanyByCompanyId(job.company_id)" class="jobs_detail_table_rows" v-if="item.resourceField[0].name.startsWith(jobSettingProperty.ITEM_COMPANY_MODIFY) && getCompanyByCompanyId(job.company_id) && job[companyDispatchPublicSetting] === 1"
                              v-bind:key="item.resourceField[0].name">
                            <th class="jobs_detail_table_head"
                                v-bind:style="[{ backgroundColor: colorSetting.subColor }, index === 0 ? { border: '1px solid' + colorSetting.borderColor } : {borderLeft: '1px solid' + colorSetting.borderColor, borderRight: '1px solid' + colorSetting.borderColor, borderBottom: '1px solid' + colorSetting.borderColor}]">
                              <span v-bind:style="{ color: colorSetting.pageText }" class="setting_word_break">
                                {{ item.itemName }}
                              </span>
                            </th>
                            <td class="jobs_detail_table_cell word-break" v-bind:style="{borderTop: '1px solid' + colorSetting.borderColor, borderRight: '1px solid' + colorSetting.borderColor, borderBottom: '1px solid' + colorSetting.borderColor}">
                              <span v-if="item.resourceField[0].type === 'free_email'">
                                <a v-bind:style="{ color: colorSetting.linkText }" :href="'mailto:' + companyData[item.resourceField[0].name.substring(8)]">
                                  {{ companyData[item.resourceField[0].name.substring(8)] }}
                                </a>
                              </span>
                              <span v-else-if="item.resourceField[0].type === 'url'">
                                <a v-bind:style="{ color: colorSetting.linkText }" :href="companyData[item.resourceField[0].name.substring(8)]" target="_blank">
                                  {{ companyData[item.resourceField[0].name.substring(8)] }}
                                </a>
                              </span>
                              <span v-else-if="TYPE_OF_SINGLE_SELECT.includes(item.resourceField[0].type) && item.resourceField[0].master_name && item.resourceField[0].name">
                                {{ getSingleSelectValue(item.resourceField[0].master_name, companyData[item.resourceField[0].name.substring(8)]) }}
                              </span>
                              <span v-else-if="TYPE_OF_MULTI_SELECT.includes(item.resourceField[0].type) && item.resourceField[0].master_name && item.resourceField[0].name">
                                <span v-for="(value, index) in getMultiSelectValue(item.resourceField[0].master_name, companyData[item.resourceField[0].name.substring(8)])" :key="index">
                                  <span v-if="index !== 0">, </span>
                                  <span>{{ value }}</span>
                                </span>
                              </span>
                              <span v-else-if="FORMAT_DATE.includes(item.resourceField[0].type)">
                                {{ getDatetimeString(item.resourceField[0].type, companyData[item.resourceField[0].name.substring(8)]) }}
                              </span>
                              <span class="white-space" v-else-if="item.resourceField[0].type === 'textarea'">{{ companyData[item.resourceField[0].name.substring(8)] }}</span>
                              <span v-else-if="TYPE_OF_NUMBER.includes(item.resourceField[0].type)">
                                {{formatNumberByStep(companyData[item.resourceField[0].name.substring(8)], item.resourceField[0].step)}}
                              </span>
                              <span v-else-if="isObjectDataHasValue(companyData[item.resourceField[0].name.substring(8)])">{{ companyData[item.resourceField[0].name.substring(8)].data }}</span>
                              <span v-else>{{ companyData[item.resourceField[0].name.substring(8)] }}</span>
                              <span v-if="item.resourceField[0].unit" class="ml-1" :class="{'label_unit_item_long': item.resourceField[0].unit.length > userConfig.UNIT_LENGTH, 'label_unit_item': item.resourceField[0].unit.length <= userConfig.UNIT_LENGTH}">{{ item.resourceField[0].unit }}</span>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </template>
                </template>
              </div>
              <div class="jobs_result_btn">
                <button class="jobs_btn_primary"
                  v-bind:style="{
                    color: colorSetting.mainButtonText,
                    backgroundColor: colorSetting.mainButton
                  }"
                  @click="viewDetailJob(job.id, DISPATCH_DETAIL_FORM_TYPE)"
                >
                  <span v-if="button.listBtn === ''">
                    {{ searchJobLabelsProperty.VIEW_DETAIL_JOB }}
                  </span>
                  <span v-else>
                    {{ button.listBtn }}
                  </span>
                </button>
              </div>
            </li>
          </ul>
        </div>
        <div class="jobs_btn_box">
          <button class="jobs_btn_secondary jobs_btn_medium"
            v-bind:style="{
              color: colorSetting.subButtonText,
              backgroundColor: colorSetting.subButton
            }"
            v-if="maxResultJobDisplay < idJobs.length" :class="page !== 1 ? '' : 'jobs_btn_disabled'" @click="previousPage">
            {{ searchJobLabelsProperty.BUTTON_BACK_PAGE }}
          </button>
          <button class="jobs_btn_secondary jobs_btn_medium"
            v-bind:style="{
              color: colorSetting.subButtonText,
              backgroundColor: colorSetting.subButton
            }"
            v-if="page < pages.length && toJob < totalResultSearchJob" @click="nextPage">
            {{ searchJobLabelsProperty.BUTTON_NEXT_PAGE }}
          </button>
        </div>
      </div>
    </div>
    <div class="setting_botton_top" ref="ref_botton_top">
      <button v-bind:style="{color: colorSetting.mainButtonText, backgroundColor: colorSetting.mainButton, border: '1px solid' + colorSetting.borderColor}" class="setting_btn_primary" @click="onTopPage">
        <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 320 512" height="1em" width="1em"><path d="M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z"></path></svg>
      </button>
    </div>
    <div class="setting_btn_print" v-if="isDisplayPrint">
      <button v-bind:style="{color: colorSetting.mainButtonText, backgroundColor: colorSetting.mainButton, border: '1px solid' + colorSetting.borderColor}" class="setting_btn_primary" @click="printPage()">
        <svg xmlns="http://www.w3.org/2000/svg" width="1rem" height="1rem" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 6 2 18 2 18 9"></polyline><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path><rect x="6" y="14" width="12" height="8"></rect></svg>
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import InputComponent from "../CommonSettings/GeneralComponents/InputComponent.vue";
import VueToast from "vue-toast-notification";
import labelProperties from "../../properties/job_screen/customize_tab/popup-customize/popup-customize-labels.json";
import masterSettingService from "../../services/MasterSettingsService";
import formSettingService from "../../services/FormSettingService";
import entrySettingNotificationProperty from "../../properties/entry_screen/notifications.json";
import userService from "../../services/UserService";
import moment from "moment";
import momenttz from "moment-timezone";
import jobSettingService from "@/services/JobSettingService";
import searchJobLabelsProperty from "../../properties/user_search_job_screen/search-job-labels.json";
import jobSettingProperty from "../../properties/job_screen/job-screen.json";
import messageProperties from "../../properties/user_search_job_screen/message.json"
import {Encrypt} from "@/plugins/cryptojs";
import userConfig from "../../properties/user_entry_screen/config.json";
import configSearchJob from "../../properties/user_search_job_screen/config.json";
import commonSettingsProperties from "../../properties/common_screen/common-settings.json";
import {printf} from "fast-printf";
import authService from "../../services/AuthService";
import Utils from "../../Utils";
Vue.use(VueToast);

const SEARCH_FORM_TYPE = 1;
const DETAIL_FORM_TYPE = 2;
const LIST_FORM_TYPE = 4;
const DISPATCH_SEARCH_FORM_TYPE = 5;
const DISPATCH_DETAIL_FORM_TYPE = 6;
const DISPATCH_LIST_FORM_TYPE = 7;
const SEARCH_BUTTON_TYPE = 0;
const LIST_BUTTON_TYPE = 1;
const DETAIL_BUTTON_TYPE = 2;
const HEADING_SETTING_TYPE = 0;
const BODY_SETTING_TYPE = 1;
const NUMBER_OF_MAX_JOB_SEARCH = 50;
export default {
  name: "SearchJobPage",
  props: [
    "encryptJobCode",
    "groupName",
    "commonSetting", 
    "hash", 
    "resourcesAPI",
    "TYPE_OF_SINGLE_SELECT",
    "TYPE_OF_MULTI_SELECT",
    "FORMAT_DATE",
    "TYPE_OF_NUMBER",
    "getDatetimeString",
    "formatNumberByStep",
    "isPreviousItemHaveData",
    "isObjectDataHasValue",
    "isDisplayPrint"
  ],
  components: {
    InputComponent,
  },
  data: function () {
    return {
      homepagePostingSetting: "",
      homepageDispatchPostingSetting: "",
      companies: [],
      staffs: [],
      companyPublicSetting: "",
      companyDispatchPublicSetting: "",
      pages: [],
      pagesDispatch: [],
      pagesPrelusion: [],
      page: 1,
      pageDispatch: 1,
      pagePrelusion: 1,
      detailSettings: [],
      bodySettings: [],
      headingSettings: [],
      headingDispatchJobSettings: [],
      bodyDispatchJobSettings: [],
      totalResultSearchJob: 0,
      totalResultSearchDispatchJob: 0,
      totalResultSearchPrelusionJob: 0,
      maxResultJobDisplay: 50,
      freeWord: "",
      condition: "or",
      categoriesJobSearch: [],
      categoriesJobList: [],
      categoriesJobDetail: [],
      bodyHeadingJobSetting: [],
      categoriesDispatchJobList: [],
      categoriesDispatchJobDetail: [],
      bodyHeadingDispatchJobSettings: [],
      colorSetting: {},
      jobSearchPageName: "",
      jobSearchPageOverview: "",
      resource: {},
      jobSearchForm: {},
      master: {},
      masters: [],
      button: {
        searchBtn: "",
        listBtn: "",
        detailBtn: ""
      },
      isSearched: false,
      labelProperties: labelProperties,
      entrySettingNotificationProperty: entrySettingNotificationProperty,
      searchJobLabelsProperty: searchJobLabelsProperty,
      jobSettingProperty: jobSettingProperty,
      userConfig: userConfig,
      configSearchJob: configSearchJob,
      keyMasters: [],
      jobDetails: [],
      dispatchJobDetails: [],
      prelusionJobDetails: [],
      itemStored: [],
      jobResourceFields: {},
      dispatchJobResourceFields: {},
      searchJobDto: {
        isKeyLimitDisabled: true,
        sort: [
          {
            updated_at: "desc"
          },
        ],
        take: configSearchJob.TAKE_JOB,
        page: 1,
        and: []
      },
      searchDispatchJobDto: {
        isKeyLimitDisabled: true,
        sort: [
          {
            updated_at: "desc"
          },
        ],
        take: configSearchJob.TAKE_JOB,
        page: 1,
        and: []
      },
      searchCompanyJobDto: {
        isKeyLimitDisabled: true,
        sort: [
          {
            updated_at: "desc"
          },
        ],
        take: configSearchJob.TAKE_JOB,
        page: 1,
        and: [
        ]
      },
      idJobs: [],
      idDispatchJobs: [],
      idPrelusionJobs: [],
      fromJob: 1,
      toJob: Number,
      fromDispatchJob: 1,
      toDispatchJob: Number,
      fromPrelusionJob: 1,
      toPrelusionJob: Number,
      isLoadingData: false,
      numberOfSearchByItem: 0,
      heightPageJobSearch: 0,
      timer: false,
      keyRedisSearch: "",
      lastPage: 0,
      jobNewWindow: false,
      lastDispatchPage: 0,
      lastPrelusionPage: 0,
      jobViewDetails:[],
      isSettingViewJob: false,
      isHasPropertySearchJob: false,
      isSettingViewDispatchJob: false,
      isHasPropertySearchDispatch: false,
      DETAIL_FORM_TYPE: DETAIL_FORM_TYPE,
      DISPATCH_DETAIL_FORM_TYPE: DISPATCH_DETAIL_FORM_TYPE,
      itemValue: "",
      listMasterApiData: [],
      companyIds: [],
      ITEM_SEARCH_JOB_UNSUPPORT: commonSettingsProperties.ITEM_SEARCH_JOB_UNSUPPORT,
      itemUnSupportSearchHasValue: 0
    };
  },

  async created() {
    this.isLoadingData = true;
    await this.getPageStatus();
    if (this.commonSetting && this.commonSetting.jobSearchPageName) {
      this.jobSearchPageName = this.commonSetting.jobSearchPageName;
    }

    if (this.commonSetting && this.commonSetting.jobPageOverview) {
      this.jobSearchPageOverview = this.commonSetting.jobPageOverview;
    }

    document.title = searchJobLabelsProperty.SEARCH_PAGE_TITLE;
    await this.getSearchFormDataSetting(this.hash);
    await this.getJobDetailFormDataSetting(this.hash);
    await this.getJobSearchFreeWordFormDataSetting(this.hash);
    await this.getMasters(true, this.hash);
    await this.getJobResourceFields(this.hash);
    if (this.commonSetting.dispatchPublic) {
      await this.getDispatchSearchFormSetting(this.hash);
      await this.getDispatchJobListFormSetting(this.hash);
      await this.getDispatchJobDetailFormSetting(this.hash);
      await this.getDispatchJobResourceFields(this.hash);
    }

    if (this.$route.query.query) {
      await userService.getQuery(this.$route.query.query, this.hash).then( async response => {
        if (response && response.data) {
          if (response.data.category) {
            this.categoriesJobSearch = response.data.category;
            this.convertDateTimeValue();
          }

          if (response.data.freeWord) {
            this.freeWord = response.data.freeWord;
          }

          if (response.data.condition) {
            this.condition = response.data.condition;
          }
          if(!this.$route.query.top){
            await this.searchJobDetail();
          }else{
            this.isLoadingData = false;
          }

        } else {
          this.isLoadingData = false;
        }
      })
    } else {
      this.isLoadingData = false;
    }

    let elementResize = document.getElementById("resize_iframe");
    if (window.parent && elementResize) {
      this.heightPageJobSearch = elementResize.clientHeight;
      window.parent.postMessage(["resized", {height: this.heightPageJobSearch}], "*");
    }
    document.body.style.backgroundColor = this.colorSetting.pageBackground ? this.colorSetting.pageBackground :"#FFFF";
    this.loadResized();

    document.body.addEventListener('scroll', (e) => {
      if (this.$refs.ref_botton_top) {
        this.$refs.ref_botton_top.style.display = "none";
        if (e.target.scrollTop > 20) {
          this.$refs.ref_botton_top.style.display = "block";
        }
      }
    });
  },

  updated() {
    window.onresize = () => {
      this.loadResized();
    };
  },

  methods: {
    convertDateTimeValue(){
      if(!this.categoriesJobSearch || !Array.isArray(this.categoriesJobSearch) || this.categoriesJobSearch.length <= 0){
        return;
      }
      this.categoriesJobSearch.filter(category => category && Array.isArray(category.item) && category.item.length > 0).forEach(category =>{
        category.item.filter(itemSetting => itemSetting && Array.isArray(itemSetting.resourceField) && itemSetting.resourceField.length > 0).forEach(itemSetting => {
          let resource = itemSetting.resourceField[0];
          if(resource && this.FORMAT_DATE.includes(resource.type)){
            if(resource.default_value_from){
              resource.default_value_from = new Date(resource.default_value_from);
            }
            if(resource.default_value_to){
              resource.default_value_to = new Date(resource.default_value_to);
            }
          }
        })
      })
    },

    getSubItemValue(job, nameReource){
      if(!nameReource) return "";
      let origrinNameReource = nameReource.split('.');
      if(origrinNameReource.length > 1){
        let jobData = job[origrinNameReource[0]];
        if(Array.isArray(jobData)){
          let values = [];
          jobData.filter(value => value[origrinNameReource[1]]).forEach(value =>{
            values.push(value[origrinNameReource[1]]);
          });
          return values;
        }
        return jobData ? job[origrinNameReource[0]][origrinNameReource[1]]: "";
      }
      return job[nameReource] ? job[nameReource]: "";
    },

    filterResourceField(resourceFields){
      if(!resourceFields || !Array.isArray(resourceFields) || resourceFields.length <=0 ){
        return [];
      }
      let resourceFieldNotDeleted = resourceFields.filter(resource => resource && !resource.isDeletedByMainSystem);
      if(resourceFieldNotDeleted.length <= 0){
        return [];
      }
      let itemViewSearch = resourceFieldNotDeleted[0];
      if(resourceFieldNotDeleted.length === 1 || itemViewSearch.type !== "integer"){
        return [itemViewSearch];
      }
      if(!itemViewSearch.unit){
        itemViewSearch.unit = resourceFieldNotDeleted[1].unit;
      }
      return [itemViewSearch];
    },

    loadResized() {
      if (this.timer !== false) {
        clearTimeout(this.timer);
      }

      this.timer = setTimeout(this.resetHeightIframe(), 200);
      let windowWidth = window.innerWidth;
      document.body.className = (windowWidth >= 768) ? "scroll-bar print-body-pc": "scroll-bar";
    },

    resetHeightIframe() {
      if (window.parent && document.getElementById("resize_iframe")) {
        let heightPage = document.getElementById("resize_iframe").clientHeight;
        window.parent.postMessage(["resized", {height: heightPage}], "*");
      }
    },

    checkItemSearchHasValue() {
      this.numberOfSearchByItem = 0;
      this.categoriesJobSearch.forEach(category => category.item.filter(itemJob => itemJob.resourceField && itemJob.resourceField.length > 0).forEach(itemJob => {
        if (itemJob.resourceField[0].type === "checkbox" || itemJob.resourceField[0].type === "multi_select") {
          itemJob.resourceField[0]['isHasValue'] = itemJob.resourceField[0] && itemJob.resourceField[0].default_value && itemJob.resourceField[0].default_value.length;
        } else {
          itemJob.resourceField[0]['isHasValue'] = itemJob.resourceField[0] && (itemJob.resourceField[0].default_value || itemJob.resourceField[0].default_value_from || itemJob.resourceField[0].default_value_to);
        }
        itemJob.resourceField[0]['isHasValue'] ? this.numberOfSearchByItem++ : this.numberOfSearchByItem;
      }));
    },

    async getSearchFormDataSetting(hash) {
      await formSettingService.getFormSettingByType(SEARCH_FORM_TYPE, hash).then(response => {
        if (!response || !response.data || !response.data.id) {
          return;
        }

        this.jobSearchForm = response.data;
        this.categoriesJobSearch = response.data.categorySetting;
        this.colorSetting = response.data.customizeSetting;
        if (response.data.displaySetting) {
          this.maxResultJobDisplay = response.data.displaySetting.displayRecord ? response.data.displaySetting.displayRecord : 50;
          this.companyPublicSetting = response.data.displaySetting.companyPublicSetting;
          this.homepagePostingSetting = response.data.displaySetting.homepagePostingSetting;
          this.jobNewWindow = response.data.displaySetting.jobNewWindow;
        }

        this.handleInputBtn();
        this.handleInputBodyHeadingSetting();
      }).catch(e => {
        console.log(e);
      });
    },

    async getJobDetailFormDataSetting(hash) {
      await formSettingService.getFormSettingByType(LIST_FORM_TYPE, hash).then(response => {
        if (!response || !response.data || !response.data.id) {
          return;
        }

        this.detailSettings = response.data;
        this.categoriesJobList = response.data.categorySetting;
      }).catch(e => {
        console.log(e);
      });
    },

    async getJobSearchFreeWordFormDataSetting(hash) {
      await formSettingService.getFormSettingByType(DETAIL_FORM_TYPE, hash).then(response => {
        if (!response || !response.data || !response.data.id) {
          return;
        }
        this.categoriesJobDetail = response.data.categorySetting;
        this.bodyHeadingJobSetting = response.data.bodyHeadingSetting;
      }).catch(e => {
        console.log(e);
      });
    },

    async getDispatchSearchFormSetting(hash){
      await formSettingService.getFormSettingByType(DISPATCH_SEARCH_FORM_TYPE, hash).then(response => {
        if (!response || !response.data || !response.data.displaySetting) {
          return;
        }
        this.companyDispatchPublicSetting = response.data.displaySetting.companyPublicSetting;
        this.homepageDispatchPostingSetting = response.data.displaySetting.homepagePostingSetting;
        this.handleInputBodyHeadingDispatchJobSetting(response.data);
      }).catch(e => {
        console.log(e);
      });
    },

    async getDispatchJobListFormSetting(hash){
      await formSettingService.getFormSettingByType(DISPATCH_LIST_FORM_TYPE, hash).then(response => {
        if (!response || !response.data || !response.data.categorySetting) {
          return;
        }
        this.categoriesDispatchJobList = response.data.categorySetting;
      }).catch(e => {
        console.log(e);
      });
    },

    async getDispatchJobDetailFormSetting(hash){
      await formSettingService.getFormSettingByType(DISPATCH_DETAIL_FORM_TYPE, hash).then(response => {
        if (!response || !response.data || !response.data.categorySetting) {
          return;
        }
        this.categoriesDispatchJobDetail = response.data.categorySetting;
        this.bodyHeadingDispatchJobSettings = response.data.bodyHeadingSetting;
      }).catch(e => {
        console.log(e);
      });
    },

    handleInputBodyHeadingDispatchJobSetting(headingBody){
      if(!headingBody.bodyHeadingSetting || headingBody.bodyHeadingSetting.length <= 0){
        return;
      }

      this.headingDispatchJobSettings = [];
      this.bodyDispatchJobSettings = [];
      headingBody.bodyHeadingSetting.forEach(setting => {
        switch (setting.type) {
          case HEADING_SETTING_TYPE: {
            this.headingDispatchJobSettings.push(setting);
            break;
          }
          case BODY_SETTING_TYPE: {
            this.bodyDispatchJobSettings.push(setting);
            break;
          }
        }
      });
    },


    handleInputBodyHeadingSetting() {
      this.headingSettings = [];
      this.bodySettings = [];
      this.jobSearchForm.bodyHeadingSetting.forEach(setting => {
        switch (setting.type) {
          case HEADING_SETTING_TYPE: {
            this.headingSettings.push(setting);
            break;
          }
          case BODY_SETTING_TYPE: {
            this.bodySettings.push(setting);
            break;
          }
        }
      });
    },

    async getMasters(duplicate, hash) {
      this.isLoadingData = true;
      await masterSettingService.getAll(duplicate, hash).then(response => {
        if (response && response.data != null) {
          this.masters = response.data;
        }
      }).catch(e => {
        console.log(e);
      }).finally(() => {
        if (!this.$route.query.query) {
          this.isLoadingData = false;
        }
      })
    },

    getMasterData(master_name) {
      for (const master in this.masters) {
        if (master === master_name) {
          return [...this.masters[master].items];
        }
      }
    },

    // 紹介求人のフリーワード検索
    buildConditionSearchJobByFreeWord(freeWords) {
      let isSettingViewJob = this.homepagePostingSetting !== "" && this.homepagePostingSetting.startsWith("free_boolean");

      if(!isSettingViewJob) {
        return;
      }

      // 検索対象項目の統合
      const searchCategories = [];
      
      // 詳細ページの項目設定
      if(this.categoriesJobDetail && this.categoriesJobDetail.length > 0) {
        searchCategories.push(...this.categoriesJobDetail);
      }
      
      // 一覧ページの項目設定
      if(this.categoriesJobList && this.categoriesJobList.length > 0) {
        searchCategories.push(...this.categoriesJobList);
      }

      // 見出し・本文項目をカテゴリ形式に変換して設定
      if(this.bodyHeadingJobSetting && this.bodyHeadingJobSetting.length > 0) {
        const bodyHeadingCategory = this.convertBodyHeadingToSearchCategory(this.bodyHeadingJobSetting, this.jobResourceFields);
        if(bodyHeadingCategory && bodyHeadingCategory.item.length > 0) {
          searchCategories.push(bodyHeadingCategory);
        }
      }

      if(searchCategories.length === 0) {
        return;
      }

      this.searchJobDto.and = [];
      this.searchCompanyJobDto.and = [];
      let tempSearchCompany = { or: [] };
      let temConditionJobFreeWord = { or: [] };
      
      freeWords.forEach(freeWord => {
        let conditionJobFreeWord = { or: [] };
        let conditionCompanyFreeWord = { or: [] };
        
        searchCategories.forEach(category => category.item.filter(itemJob => itemJob && itemJob.resourceField && itemJob.resourceField.length > 0).forEach(itemJob => {
          itemJob.resourceField.filter(resource => resource && resource.type && resource.name && !resource.isDeletedByMainSystem).forEach(resource => {
            let typeSearchByFreeWord = resource.type === "textarea" || resource.type === "text" || resource.type.includes('mail') || resource.type === "url";

            if(!resource.name.startsWith(jobSettingProperty.ITEM_COMPANY_MODIFY)){
              // 紹介求人
          
              // テキストの検索条件作成
              if (typeSearchByFreeWord && resource.name) {
                let subConditionFreeWord = {
                  contains: {}
                };
                if(resource.type.includes('mail') && resource.name.includes("free_mail_")){
                  subConditionFreeWord.contains[`${resource.name}.data`] = `${freeWord}`;
                }else{
                  subConditionFreeWord.contains[`${resource.name}`] = `${freeWord}`;
                }
                conditionJobFreeWord.or.push(subConditionFreeWord);
              }

              // 選択肢の検索条件作成
              const choiceCondition = this.createChoiceSearchCondition(resource, freeWord);
              if (choiceCondition) {
                conditionJobFreeWord.or.push(choiceCondition);
              }

              // ID検索の条件作成
              let typeSearchById = resource.type === "sequence";
              if (typeSearchById && resource.name && resource.name === "id") {
                let subInCondition = {
                  in: {}
                };
                let ids = [];
                const regex = /\d+/;
                freeWords.filter(freeWord => !Number.isNaN(Number(freeWord)) && freeWord.indexOf(".") === -1 && !freeWord.startsWith("0") && freeWord.match(regex)).forEach(freeWord => {
                  ids.push(freeWord);
                });
                if(ids.length > 0){
                  subInCondition.in[`${resource.name}`] = ids;
                  conditionJobFreeWord.or.push(subInCondition);
                }
              }
            }else{
              // 紹介会社

              // テキストの検索条件作成
              if (typeSearchByFreeWord && resource.name) {
                let subConditionFreeWord = {
                  contains: {}
                };
                if(resource.type.includes('mail') && resource.name.includes("free_mail_")){
                  subConditionFreeWord.contains[`${resource.name}.data`] = `${freeWord}`;
                }else{
                  subConditionFreeWord.contains[`${resource.name}`] = `${freeWord}`;
                }
                conditionCompanyFreeWord.or.push(subConditionFreeWord);
              }

              // 選択肢の検索条件作成
              const choiceCondition = this.createChoiceSearchCondition(resource, freeWord);
              if (choiceCondition) {
                conditionCompanyFreeWord.or.push(choiceCondition);
              }
            }
          });
        }));
        
        if (conditionJobFreeWord.or.length > 0) {
          temConditionJobFreeWord.or.push(conditionJobFreeWord);
        }
        if (conditionCompanyFreeWord.or.length > 0) {
          tempSearchCompany.or.push(conditionCompanyFreeWord);
        }
      });
      
      if (temConditionJobFreeWord.or.length > 0) {
        let searchJobByFreeWord = {};
        searchJobByFreeWord[`${this.condition}`] = temConditionJobFreeWord.or;
        this.searchJobDto.and.push(searchJobByFreeWord);
      }
      if (tempSearchCompany.or.length > 0) {
        let addCompanayJobItem = {};
        addCompanayJobItem[`${this.condition}`] = tempSearchCompany.or;
        this.searchCompanyJobDto.and.push(addCompanayJobItem);
      }
    },

    // 派遣求人のフリーワード検索
    buildConditionSearchDispatchJobByFreeWord(freeWords) {
      let isSettingViewDispatchJob = this.homepageDispatchPostingSetting !== "" && this.homepageDispatchPostingSetting.startsWith("free_boolean");

      if(!isSettingViewDispatchJob) {
        return;
      }

      // 検索対象項目の統合
      const searchCategories = [];
      
      // 派遣求人一覧ページの項目設定
      if(this.categoriesDispatchJobList && this.categoriesDispatchJobList.length > 0) {
        searchCategories.push(...this.categoriesDispatchJobList);
      }
      
      // 派遣求人詳細ページの項目設定
      if(this.categoriesDispatchJobDetail && this.categoriesDispatchJobDetail.length > 0) {
        searchCategories.push(...this.categoriesDispatchJobDetail);
      }

      // 見出し・本文項目をカテゴリ形式に変換して設定
      if(this.bodyHeadingDispatchJobSettings && this.bodyHeadingDispatchJobSettings.length > 0) {
        const bodyHeadingCategory = this.convertBodyHeadingToSearchCategory(this.bodyHeadingDispatchJobSettings, this.dispatchJobResourceFields);
        if(bodyHeadingCategory && bodyHeadingCategory.item.length > 0) {
          searchCategories.push(bodyHeadingCategory);
        }
      }

      if(searchCategories.length === 0) {
        return;
      }

      this.searchDispatchJobDto.and = [];
      let tempSearchCompany = [];
      let temConditionJobFreeWord = { or: [] };
      let isPushCompanyCodition = false;
      let companyJobItems = this.searchCompanyJobDto.and.filter(condition => condition && condition[`${this.condition}`] && Array.isArray(condition[`${this.condition}`]))[0];
      if(!companyJobItems){
        companyJobItems = {};
        companyJobItems[`${this.condition}`] = [];
        isPushCompanyCodition = true;
      }
      
      freeWords.forEach((freeWord, index) => {
        let conditionFreeWord = { or: [] };
        let conditionCompanyFreeWord = { or: [] };
        
        searchCategories.forEach(category => category.item.filter(itemJob => itemJob && itemJob.resourceField && itemJob.resourceField.length > 0).forEach(itemJob => {
          itemJob.resourceField.filter(resource => resource && resource.type && resource.name && !resource.isDeletedByMainSystem).forEach(resource => {
            let typeSearchByFreeWord = resource.type === "textarea" || resource.type === "text" || resource.type.includes('mail') || resource.type === "url";
            
            if(!resource.name.startsWith(jobSettingProperty.ITEM_COMPANY_MODIFY)){
              // 派遣求人
          
              // テキストの検索条件作成
              if (typeSearchByFreeWord && resource.name) {
                  let subConditionFreeWord = {
                    contains: {}
                  };
                  let nameResourceDispatch = jobSettingProperty.ITEM_DISPATCH_MODIFY + resource.name;
                  if(resource.type.includes('mail') && resource.name.includes("free_mail_")){
                    subConditionFreeWord.contains[`${nameResourceDispatch}.data`] = `${freeWord}`;
                  }else{
                    subConditionFreeWord.contains[`${nameResourceDispatch}`] = `${freeWord}`;
                  }
                  conditionFreeWord.or.push(subConditionFreeWord);
              }

              // 選択肢の検索条件作成
              const choiceCondition = this.createChoiceSearchCondition(resource, freeWord);
              if (choiceCondition) {
                conditionFreeWord.or.push(choiceCondition);
              }

              // ID検索の条件作成
              let typeSearchById = resource.type === "sequence";
              if (typeSearchById && resource.name && resource.name === "id") {
                let subInCondition = {
                  in: {}
                };
                let ids = [];
                const regex = /\d+/;
                freeWords.filter(freeWord => !Number.isNaN(Number(freeWord)) && freeWord.indexOf(".") === -1 && !freeWord.startsWith("0") && freeWord.match(regex)).forEach(freeWord => {
                  ids.push(freeWord);
                });
                if(ids.length > 0){
                  subInCondition.in[`${resource.name}`] = ids;
                  conditionFreeWord.or.push(subInCondition);
                }
              }
            }else{
              // 派遣会社

              // テキストの検索条件作成
              if (typeSearchByFreeWord && resource.name) {
                let subConditionFreeWord = {
                  contains: {}
                };
                if(resource.type.includes('mail') && resource.name.includes("free_mail_")){
                  subConditionFreeWord.contains[`${resource.name}.data`] = `${freeWord}`;
                }else{
                  subConditionFreeWord.contains[`${resource.name}`] = `${freeWord}`;
                }
                conditionCompanyFreeWord.or.push(subConditionFreeWord);
              }

              // 選択肢の検索条件作成
              const choiceCondition = this.createChoiceSearchCondition(resource, freeWord);
              if (choiceCondition) {
                conditionCompanyFreeWord.or.push(choiceCondition);
              }
            }
          });
        }));

        if (conditionFreeWord.or.length > 0) {
          temConditionJobFreeWord.or.push(conditionFreeWord);
        }
        if (conditionCompanyFreeWord.or.length > 0) {
          let addOrCondition = {or: []};
          let newConditionSearchCompany = companyJobItems[`${this.condition}`][index] ? companyJobItems[`${this.condition}`][index] : {or: []};
          if(newConditionSearchCompany && Array.isArray(newConditionSearchCompany.or)){
            const mergedCompanyItems = conditionCompanyFreeWord.or.concat(newConditionSearchCompany.or);
            conditionCompanyFreeWord = Array.from(new Set(mergedCompanyItems.map(JSON.stringify))).map(JSON.parse);
          }
          addOrCondition.or = conditionCompanyFreeWord;
          tempSearchCompany.push(addOrCondition);
        }
      });
      
      if (temConditionJobFreeWord.or.length > 0) {
        let searchJobByFreeWord = {};
        searchJobByFreeWord[`${this.condition}`] = temConditionJobFreeWord.or;
        this.searchDispatchJobDto.and.push(searchJobByFreeWord);
      }
      if (tempSearchCompany.length > 0) {
        companyJobItems[`${this.condition}`] = tempSearchCompany;
        if(isPushCompanyCodition) this.searchCompanyJobDto.and.push(companyJobItems);
      }
    },

    // 見出し・本文項目をsearchCategory形式に変換するヘルパーメソッド
    convertBodyHeadingToSearchCategory(bodyHeadingSettings, resourceFields) {
      const items = bodyHeadingSettings
        .filter(bodySetting => bodySetting && bodySetting.name && !bodySetting.isDeletedByMainSystem)
        .map(bodySetting => {
          // リソース情報を取得
          // 検索処理でリソースのtypeによって検索方法を決定しているが、見出し・本文項目にはtypeが含まれていないためResourceFieldsから取得する必要がある
          let resourceInfo = { type: "text", master_name: null }; // デフォルト
          if(resourceFields && resourceFields[bodySetting.name]) {
            resourceInfo = resourceFields[bodySetting.name];
          } else if(bodySetting.name.includes('.')) {
            const keys = bodySetting.name.split('.');
            if(resourceFields && resourceFields[keys[0]] && resourceFields[keys[0]][keys[1]]) {
              resourceInfo = resourceFields[keys[0]][keys[1]];
            }
          }

          // searchCategory形式のアイテムを作成
          return {
            itemName: bodySetting.display_name || bodySetting.name,
            resourceField: [{
              id: `resource_${bodySetting.id || bodySetting.name}`,
              name: bodySetting.name,
              display_name: bodySetting.display_name || bodySetting.name,
              type: resourceInfo.type,
              master_name: resourceInfo.master_name || null,
              required: false,
              isDeletedByMainSystem: false,
            }]
          };
        });
        
      return {
        categoryName: '見出し・本文項目',
        item: items
      };
    },

    // 選択肢の検索条件を作成する共通メソッド
    createChoiceSearchCondition(resource, freeWord) {
      if (!resource.name || !resource.master_name) {
        return null;
      }

      const matchingChoiceIds = this.findMatchingChoiceIds(resource.master_name, freeWord);
      if (matchingChoiceIds.length === 0) {
        return null;
      }

      return {
        in: {
          [resource.name]: matchingChoiceIds
        }
      };
    },

    // フリーワードにマッチする選択肢のchoiceIdを取得するヘルパーメソッド
    findMatchingChoiceIds(masterName, freeWord) {
      const masterData = this.getMasterData(masterName);
      if (!masterData || !Array.isArray(masterData)) {
        return [];
      }

      // (セキュリティ対策)入力値のサニタイゼーション
      const sanitizedFreeWord = String(freeWord).trim();
      if (!sanitizedFreeWord) {
        return [];
      }

      // choiceIdを抽出
      const matchingChoiceIds = masterData
        .filter(item => {
          // 非表示の選択肢は除外
          if (!item.show) return false;
          
          // choiceNameのnullチェック
          const choiceName = item.choiceName;
          if (!choiceName || typeof choiceName !== 'string') return false;
          
          // choiceNameでマッチング
          return choiceName.toLowerCase().includes(sanitizedFreeWord.toLowerCase());
        })
        .map(item => item.choiceId);

      // 重複を除去
      return [...new Set(matchingChoiceIds)];
    },

    buildConditionSearchJobByItem(isSearchJob) {
      let objectSearch = {
        and: []
      };
      this.categoriesJobSearch.forEach(category => category.item.filter(itemJob => itemJob.resourceField && itemJob.resourceField.length > 0).forEach(itemJob => {
        let resourceHasValue = itemJob.resourceField[0];
          itemJob.resourceField.filter(resource => resource && resource.name && !resource.isDeletedByMainSystem && (resource.name.startsWith(jobSettingProperty.ITEM_DISPATCH_MODIFY) === isSearchJob)).forEach(resource => {
            resource.default_value = resourceHasValue ? resourceHasValue.default_value : "";
            resource.default_value_from = resourceHasValue ? resourceHasValue.default_value_from : "";
            resource.default_value_to = resourceHasValue ? resourceHasValue.default_value_to : "";

            let subContainType = resource.type === "textarea" || resource.type === "text" || resource.type === "url" || resource.type.includes("email") || resource.type === "tel";
            if (resource.default_value && subContainType) {
              let subContain = {
                contains: {}
              };

              subContain.contains[`${resource.name}`] = `${resource.default_value}`;
              objectSearch.and.push(subContain);
            }

            let subSequenceType = resource.type === "sequence";
            if (resource.default_value && subSequenceType) {
              let subSequence = {
                equal: {}
              };

              subSequence.equal[`${resource.name}`] = `${resource.default_value}`;
              objectSearch.and.push(subSequence);
            }

            this.formatValueDateTime(resource);
            let conditionRange = resource.type === "integer" || resource.type === "calc" || resource.type === "number" || resource.type === "datetime" || resource.type === "date" || resource.type === "ym" || resource.type === "time";
            let conditionValueRange = resource.default_value_from && resource.default_value_to && resource.default_value_from !== "" && resource.default_value_to !== "";
            if (conditionRange && conditionValueRange) {
              let subRange = {
                range: {}
              };

              if (resource.type === "datetime" || resource.type === "date" || resource.type === "ym" || resource.type === "time") {
                subRange.range[`${resource.name}`] = [`${resource.value_from}`, `${resource.value_to}`,];
              } else {
                subRange.range[`${resource.name}`] = [`${resource.default_value_from}`, `${resource.default_value_to}`,];
              }

              objectSearch.and.push(subRange);
            }

            let conditionValueGTE = resource.default_value_from && resource.default_value_from !== "" && (!resource.default_value_to || resource.default_value_to === "");
            if (conditionRange && conditionValueGTE) {
              let subGTE = {
                gte: {}
              };
              if (resource.type === "datetime" || resource.type === "date" || resource.type === "ym" || resource.type === "time") {
                subGTE.gte[`${resource.name}`] = `${resource.value_from}`;
              } else {
                subGTE.gte[`${resource.name}`] = `${resource.default_value_from}`;
              }

              objectSearch.and.push(subGTE);
            }

            let conditionValueLTE = resource.default_value_to && resource.default_value_to !== "" && (!resource.default_value_from || resource.default_value_from === "");
            if (conditionRange && conditionValueLTE) {
              let subLTE = {
                lte: {}
              };

              if (resource.type === "datetime" || resource.type === "date" || resource.type === "ym" || resource.type === "time") {
                subLTE.lte[`${resource.name}`] = `${resource.value_to}`;
              } else {
                subLTE.lte[`${resource.name}`] = `${resource.default_value_to}`;
              }

              objectSearch.and.push(subLTE);
            }

            let conditionExact = resource.type === "single_select" || resource.type === "select" || resource.type === "radio" || resource.type === "boolean";
            if (conditionExact && resource.default_value && resource.default_value !== "" && resource.default_value.choiceId >= 0 && resource.default_value.choiceId !== null) {
              let subEqual = {
                equal: {}
              };

              subEqual.equal[`${resource.name}`] = resource.default_value.choiceId;
              objectSearch.and.push(subEqual);
            }

            if ((resource.type === "multi_select" || resource.type === "checkbox") && resource.default_value && resource.default_value.length > 0) {
              if ((resource.type === "multi_select" || resource.type === "checkbox") && resource.default_value && resource.default_value.length > 0) {
                if(!resourceHasValue.multiSelectOption) {
                  let subInMultipleChoice = {
                    in: {}
                  };

                  let values = [];
                  resource.default_value.forEach(value => values.push(value.choiceId));
                  subInMultipleChoice.in[`${resource.name}`] = values;
                  objectSearch.and.push(subInMultipleChoice);
                } else {
                  resource.default_value.forEach(value => {
                    let subEqual = {
                      equal: {}
                    };

                    subEqual.equal[`${resource.name}`] = value.choiceId;
                    objectSearch.and.push(subEqual);
                  });
                }
              }
            }
          });
        })
      );
      if(isSearchJob){
        this.searchDispatchJobDto["and"] = objectSearch.and;
      }else{
        this.searchJobDto["and"] = objectSearch.and;
      }
    },

    addConditionSearchExactly(isSearchJob) {
      let ignoreJobCondition = {
        not: []
      };
      let equalCondition = {
        equal: {}
      };

      if(isSearchJob){
        if (this.homepageDispatchPostingSetting && this.homepageDispatchPostingSetting.startsWith("free_boolean")) {
          equalCondition.equal[`${this.homepageDispatchPostingSetting}`] = 0;
          ignoreJobCondition.not.push(equalCondition);
        }
      }else{
        if (this.homepagePostingSetting && this.homepagePostingSetting.startsWith("free_boolean")) {
          equalCondition.equal[`${this.homepagePostingSetting}`] = 0;
          ignoreJobCondition.not.push(equalCondition);
        }
      }
      
      let objectSearchDto = isSearchJob ? this.searchDispatchJobDto: this.searchJobDto;
      if (this.freeWord && this.condition === "and") {
        delete objectSearchDto.and.or;
      } else if (this.freeWord && this.condition === "or") {
        delete objectSearchDto.and.and;
      }else{
        if (ignoreJobCondition.not.length > 0) {
          objectSearchDto.and.push(ignoreJobCondition);
        }
      }

      if(this.freeWord && objectSearchDto.and.length >= 0){
        if (ignoreJobCondition.not.length > 0) {
          objectSearchDto.and.push(ignoreJobCondition);
        }
      }
    },

    async searchJobDetail() {
      this.isLoadingData = true;
      await this.$emit("createLogger", "Search job page user - Click button " + (this.button.searchBtn !== "" ? this.button.searchBtn : labelProperties.CONFIRM_BUTTON));
      this.checkItemSearchHasValue();
      let freeWords = [];
      if (this.freeWord.trim().length > 0) {
        const freeWord = this.freeWord.replaceAll("　", " ");
        freeWords = freeWord.split(" ").filter(Boolean);
      }
      this.checkCategorySearchJobHasItemUnSupport();
      if (freeWords.length > 0 && this.hasSearchableCategories()) {
        if(freeWords.length > this.configSearchJob.MAXLENGTH_FREE_WORD){
          Vue.$toast.clear();
          Vue.$toast.warning(printf(messageProperties.ERROR_MAXLENGTH_FREE_WORD, this.configSearchJob.MAXLENGTH_FREE_WORD),{
            position: "bottom-right",
            duration: 3000,
          });
          this.isSearched = false;
          this.isLoadingData = false;
          return;
        }else{
          this.buildConditionSearchJobByFreeWord(freeWords);
          this.buildConditionSearchDispatchJobByFreeWord(freeWords);
        }
      } else {
        this.buildConditionSearchJobByItem(false);
        this.buildConditionSearchJobByItem(true);
      }
      await this.saveQueryToRedis(this.hash);
      this.isSettingViewJob = this.homepagePostingSetting !== "" && this.homepagePostingSetting.startsWith("free_boolean");
      let isItemSearchDetailJob = this.categoriesJobDetail.length > 0 && this.searchJobDto.and.length > 0;
      let isAllowSearchJob = this.isSettingViewJob && isItemSearchDetailJob;
      this.isSettingViewDispatchJob = this.homepageDispatchPostingSetting !== "" && this.homepageDispatchPostingSetting.startsWith("free_boolean");
      let isItemSearchDetailDispatchJob = this.categoriesDispatchJobDetail.length > 0 && this.searchDispatchJobDto.and.length > 0;
      let isAllowSearchDispatchJob = this.isSettingViewDispatchJob && isItemSearchDetailDispatchJob;
      if (this.itemUnSupportSearchHasValue > 0 || (!this.isSettingViewJob && !this.isSettingViewDispatchJob) ||
        (!isAllowSearchJob && !isAllowSearchDispatchJob && this.freeWord.length > 0)) {
        this.isSearched = true;
        this.idJobs = [];
        Vue.$toast.clear();
        Vue.$toast.success(messageProperties.NO_RESULT_SEARCH_JOB, {
          position: "bottom-right",
          duration: 3000,
        });

        this.isLoadingData = false;
        this.resetHeightIframe();
        this.onTopOfIframe();
        return;
      }
      await this.searchCompanyResource(this.hash);
      this.addConditionSearchExactly(false);
      this.addConditionSearchExactly(true);
      Vue.$toast.clear();
      let isSearchJobSuccess = false;
      this.isHasPropertySearchJob =  this.freeWord.length <= 0 || (this.freeWord.length > 0 && isItemSearchDetailJob);
      if(this.isSettingViewJob && this.isHasPropertySearchJob){
        await userService.searchJobFromMatchingood2nd(this.searchJobDto, this.hash).then(response => {
          if (response && response.status === 200) {
            isSearchJobSuccess = true;
            this.totalResultSearchPrelusionJob = response.data.total;
            this.lastPrelusionPage = response.data.lastPage;
            this.idPrelusionJobs = response.data.items;
            this.setJobSearchPages(false);
          }
        }).catch(e => {
          isSearchJobSuccess = false;
          this.isLoadingData = false;
          Utils.responsePageMaintenance(e);
        })
      }else{
        isSearchJobSuccess = true;
      }
      let isSearchDispatchJobSuccess = false;
      this.isHasPropertySearchDispatch =  this.freeWord.length <= 0 || (this.freeWord.length > 0 && isItemSearchDetailDispatchJob);
      if(this.isSettingViewDispatchJob && this.isHasPropertySearchDispatch){
        await userService.searchDispatchJobFromMatchingood2nd(this.searchDispatchJobDto, this.hash).then(response => {
          if (response && response.status === 200) {
            isSearchDispatchJobSuccess = true;
            this.totalResultSearchDispatchJob = response.data.total;
            this.lastDispatchPage = response.data.lastPage;
            this.idDispatchJobs = response.data.items;
            this.setJobSearchPages(true);
          }
        }).catch(e => {
          isSearchDispatchJobSuccess = false;
          this.isLoadingData = false;
          Utils.responsePageMaintenance(e);
        })
      }else{
        isSearchDispatchJobSuccess = true;
      }
      if(isSearchJobSuccess && isSearchDispatchJobSuccess){
        this.totalResultSearchJob = this.totalResultSearchPrelusionJob + this.totalResultSearchDispatchJob;
        if (this.totalResultSearchJob <= 0) {
          Vue.$toast.success(messageProperties.NO_RESULT_SEARCH_JOB, {
            position: "bottom-right",
            duration: 3000,
          });
          this.isSearched = true;
          this.isLoadingData = false;
          this.resetHeightIframe();
          this.onTopOfIframe();
          return;
        }
        await this.getJobDetails(this.idPrelusionJobs.slice(0, NUMBER_OF_MAX_JOB_SEARCH), this.hash);
        await this.getDispatchJobDetails(this.idDispatchJobs.slice(0, NUMBER_OF_MAX_JOB_SEARCH), this.hash);
        this.idJobs = this.idPrelusionJobs.concat(this.idDispatchJobs);
        let jobDetails = this.prelusionJobDetails.concat(this.dispatchJobDetails);
        this.jobDetails = jobDetails.sort((a, b) => (moment(a.updated_at).isBefore(b.updated_at) || (moment(a.updated_at).isSame(b.updated_at) && a.id < b.id )) ? 1: -1);
        this.jobViewDetails = this.paginate(this.jobDetails);
        this.setPages();
        this.toJob = this.maxResultJobDisplay;
        this.isSearched = true;
        document.title = searchJobLabelsProperty.LIST_PAGE_TITLE;
      }else{
        this.isSearched = false;
        Vue.$toast.error(messageProperties.ERROR_SEARCH_JOB, {
          position: "bottom-right",
          duration: 3000,
        });
      }
      await this.getResourceApiData(this.hash);
      this.resetHeightIframe();
      this.onTopOfIframe();
      this.handleUpdateDisplayPrint(this.detailSettings.displaySetting);
    },

    // フリーワード検索可能なカテゴリがあるかチェックするヘルパーメソッド
    hasSearchableCategories() {
      // 紹介求人の検索対象項目をチェック
      const hasJobCategories = (
        (this.searchFreeWordCategory && this.searchFreeWordCategory.length > 0) ||
        (this.categoriesJobList && this.categoriesJobList.length > 0) ||
        (this.bodyHeadingSetting && this.bodyHeadingSetting.length > 0)
      );

      // 派遣求人の検索対象項目をチェック
      const hasDispatchJobCategories = (
        (this.categoriesDispatchJobDetail && this.categoriesDispatchJobDetail.length > 0) ||
        (this.categoriesDispatchJobList && this.categoriesDispatchJobList.length > 0) ||
        (this.bodyHeadingDispatchJobSettings && this.bodyHeadingDispatchJobSettings.length > 0)
      );

      return hasJobCategories || hasDispatchJobCategories;
    },
    
    handleUpdateDisplayPrint(displaySetting){
      let settingPrint = displaySetting && displaySetting.print && this.isSearched ? displaySetting.print: false;
      this.$emit("syncCheckDisplayPrint", settingPrint);
    },

    checkCategorySearchJobHasItemUnSupport(){
      this.itemUnSupportSearchHasValue = 0;
      this.categoriesJobSearch.forEach(category => category.item.filter(itemJob => itemJob.resourceField && itemJob.resourceField.length > 0).forEach(itemJob => {
        itemJob.resourceField.filter(resource => resource && resource.name).forEach(resource => {
          let resourceName = resource.name.includes('.')? resource.name.split('.')[1]: resource.name;
          let itemHasValue = (resource.default_value || resource.default_value_from || resource.default_value_to);
          let itemUnSupport = this.ITEM_SEARCH_JOB_UNSUPPORT.includes(resourceName);
          (itemHasValue && itemUnSupport) ? this.itemUnSupportSearchHasValue++: this.itemUnSupportSearchHasValue;
        });
      }));
    },

    async searchCompanyResource(hash){
      if(this.searchCompanyJobDto.and.length <= 0 ) return;
      this.isLoadingData = true;
      await userService.searchResource('companies', this.searchCompanyJobDto, hash).then(response => {
        if (response && response.status === 200) {
          this.companyIds = response.data.items;
        }
      }).catch(e => {
        Utils.responsePageMaintenance(e);
      })
      if(this.companyIds && Array.isArray(this.companyIds) && this.companyIds.length > 0 ){
        let subConditionSearchCompany = {
          in: {
            "company_id": this.companyIds
          }
        }
        let companyJobItems = this.searchJobDto.and.filter(condition => condition && condition[`${this.condition}`] && Array.isArray(condition[`${this.condition}`]))[0];
        if(companyJobItems && companyJobItems[`${this.condition}`].length > 0){
          companyJobItems[`${this.condition}`].forEach((c) => {
            c.or.push(subConditionSearchCompany)
          });
        }
        let companyDispatchJobItems = this.searchDispatchJobDto.and.filter(condition => condition && condition[`${this.condition}`] && Array.isArray(condition[`${this.condition}`]))[0];
        if(companyDispatchJobItems && companyDispatchJobItems[`${this.condition}`].length > 0){
          companyDispatchJobItems[`${this.condition}`].forEach((c) => {
            c.or.push(subConditionSearchCompany)
          });
        }
      }
    },

    async getResourceApiData(hash){
      let companyIds = [];
      let staffIds = [];
      this.companies = [];
      this.staffs = [];

      this.jobViewDetails.filter(job => job && (job.company_id || job.staff_id)).forEach(job =>{
        if(job.company_id){
          companyIds.push(job.company_id);
          companyIds = [...new Set(companyIds)];
        }
        if(job.staff_id){
          staffIds.push(job.staff_id);
          staffIds = [...new Set(staffIds)];
        }
      });
      await this.getCompanies(companyIds, hash);
      await this.getStaffs(staffIds, hash);
    },

    async saveQueryToRedis(hash){
      this.keyRedisSearch = Encrypt(this.groupName + Date.now()).replaceAll("/","_");
      let conditionSearchJob = {
        category: this.categoriesJobSearch,
        freeWord: this.freeWord,
        condition: this.condition,
        key: this.keyRedisSearch
      }

      await userService.saveQuery(conditionSearchJob, hash).catch(e => {
        console.log(e);
      })
    },

    onTopOfIframe() {
      window.parent.postMessage(["onTopIframe", {}], "*");
    },

    formatValueDateTime(resource) {
      resource.value_from = "";
      resource.value_to = "";
      if (resource.type === "date") {
        if (resource.default_value_from !== "") {
          resource.value_from = moment(resource.default_value_from).format("YYYY-MM-DD");
        }

        if (resource.default_value_to !== "") {
          resource.value_to = moment(resource.default_value_to).format("YYYY-MM-DD");
        }
      }

      if (resource.type === "datetime") {
        if (resource.default_value_from !== "") {
          resource.value_from = momenttz.tz(resource.default_value_from, Intl.DateTimeFormat().resolvedOptions().timeZone).format();
        }

        if (resource.default_value_to !== "") {
          resource.value_to = momenttz.tz(resource.default_value_to, Intl.DateTimeFormat().resolvedOptions().timeZone).format();
        }
      }

      if (resource.type === "ym") {
        if (resource.default_value_from !== "") {
          resource.value_from = moment(resource.default_value_from).format("YYYY-MM");
          resource.value_from += "-01";
        }

        if (resource.default_value_to !== "") {
          resource.value_to = moment(resource.default_value_to).format("YYYY-MM");
          resource.value_to += "-01";
        }
      }

      if (resource.type === "time") {
        if (resource.default_value_from !== "") {
          resource.value_from = moment(resource.default_value_from).format("HH:mm:ss");
        }

        if (resource.default_value_to !== "") {
          resource.value_to = moment(resource.default_value_to).format(
              "HH:mm:ss"
          );
        }
      }

      return resource;
    },

    getValueCheckBox(values) {
      let valuesChecked = [];
      values.forEach(value => {
        if (!valuesChecked.includes(value)) {
          if (value.choiceDisplayName) {
            valuesChecked.push(value.choiceDisplayName);
          } else {
            valuesChecked.push(value.choiceName);
          }
        }
      });

      return valuesChecked.join(", ");
    },

    getSingleSelect(resource) {
      if (!resource || !resource.default_value) {
        return "--";
      }
      let resourceName = resource.name.includes('.')? resource.name.split('.')[1]: resource.name;
      if (this.ITEM_SEARCH_JOB_UNSUPPORT.includes(resourceName)) {
        return resource.default_value;
      }

      if (!resource.default_value.show) {
        return "--";
      }

      let value = resource.default_value;
      return value.choiceDisplayName ? value.choiceDisplayName : value.choiceName;
    },

    getValueDateTime(value) {
      let dateTimeFrom = "";
      let dateTimeTo = "";
      if (value.default_value_from) {
        dateTimeFrom = moment(value.default_value_from).format("YYYY-MM-DD HH:mm");
      }

      if (value.default_value_to) {
        dateTimeTo = moment(value.default_value_to).format("YYYY-MM-DD HH:mm");
      }

      let stringDateTime = "";
      if (dateTimeFrom !== "" && dateTimeTo !== "") {
        stringDateTime = dateTimeFrom + " ~ " + dateTimeTo;
      }

      if (dateTimeFrom !== "" && dateTimeTo === "") {
        stringDateTime = dateTimeFrom;
      }

      if (dateTimeFrom === "" && dateTimeTo !== "") {
        stringDateTime = dateTimeTo;
      }

      if (stringDateTime === "") {
        stringDateTime = "--";
      }

      return stringDateTime;
    },

    getValueDate(value) {
      let dateFrom = "";
      let dateTo = "";
      if (value.default_value_from) {
        dateFrom = moment(value.default_value_from).format("YYYY-MM-DD");
      }

      if (value.default_value_to) {
        dateTo = moment(value.default_value_to).format("YYYY-MM-DD");
      }

      let stringDate = "";
      if (dateFrom !== "" && dateTo !== "") {
        stringDate = dateFrom + " ~ " + dateTo;
      }

      if (dateFrom !== "" && dateTo === "") {
        stringDate = dateFrom;
      }

      if (dateFrom === "" && dateTo !== "") {
        stringDate = dateTo;
      }

      if (stringDate === "") {
        stringDate = "--";
      }

      return stringDate;
    },

    getValueYearMonth(value) {
      let ymFrom = "";
      let ymTo = "";
      if (value.default_value_from) {
        ymFrom = moment(value.default_value_from).format("yyyy/MM");
      }

      if (value.default_value_to) {
        ymTo = moment(value.default_value_to).format("yyyy/MM");
      }

      let stringYM = "";
      if (ymFrom !== "" && ymTo !== "") {
        stringYM = ymFrom + " ~ " + ymTo;
      }

      if (ymFrom !== "" && ymTo === "") {
        stringYM = ymFrom;
      }

      if (ymFrom === "" && ymTo !== "") {
        stringYM = ymTo;
      }

      if (stringYM === "") {
        stringYM = "--";
      }

      return stringYM;
    },

    getValueTime(value) {
      let timeFrom = "";
      let timeTo = "";
      if (value.default_value_from) {
        timeFrom = moment(value.default_value_from).format("HH:mm");
      }

      if (value.default_value_to) {
        timeTo = moment(value.default_value_to).format("HH:mm");
      }

      let stringTime = "";
      if (timeFrom !== "" && timeTo !== "") {
        stringTime = timeFrom + " ~ " + timeTo;
      }

      if (timeFrom !== "" && timeTo === "") {
        stringTime = timeFrom;
      }

      if (timeFrom === "" && timeTo !== "") {
        stringTime = timeTo;
      }

      if (stringTime === "") {
        stringTime = "--";
      }

      return stringTime;
    },

    handleInputBtn() {
      this.jobSearchForm.buttonSetting.forEach((btn) => {
        switch (btn.buttonType) {
          case SEARCH_BUTTON_TYPE: {
            this.button.searchBtn = btn.buttonName;
            break;
          }
          case LIST_BUTTON_TYPE: {
            this.button.listBtn = btn.buttonName;
            break;
          }
          case DETAIL_BUTTON_TYPE: {
            this.button.detailBtn = btn.buttonName;
            break;
          }
        }
      });
    },

    async returnJobSearchPage() {
      await this.$emit("createLogger", "Search job page user - Click button " + searchJobLabelsProperty.BUTTON_CHANGE_CONDITON_SEARCH);
      window.parent.postMessage(["resized", {height: this.heightPageJobSearch}], "*");
      window.location = `${window.location.origin}?c=${encodeURIComponent(this.encryptJobCode)}&query=${encodeURIComponent(this.keyRedisSearch)}&top=true`;
      this.resetHeightIframe();
      this.onTopOfIframe();
    },

    async getJobDetails(jobIds, hash) {
      if (!jobIds || jobIds.length === 0) {
        this.prelusionJobDetails = [];
        this.isLoadingData = false;
        return;
      }
      this.isLoadingData = true;
      await this.getDataJobOrDispatchJobDetail(jobIds, false, hash);
    },


    async getDispatchJobDetails(jobIds, hash) {
      if (!jobIds || jobIds.length === 0) {
        this.dispatchJobDetails = [];
        this.isLoadingData = false;
        return;
      }
      this.isLoadingData = true;
      await this.getDataJobOrDispatchJobDetail(jobIds, true, hash);
    },

    settingListMasterInfoAPI(job, field){
      let master = this.resourcesAPI.filter(resource_api => field.endsWith(resource_api.field))[0];
      if(!master) return;
      let value = this.getSubItemValue(job, field);
      if(value === "") return;
      let oldResource = this.listMasterApiData.filter(resource => resource && resource.master_name && resource.master_name === master.path)[0];
      value = Array.isArray(value) ? value : [value];
      if(oldResource){
        if(value){
          let newValue = [...oldResource.ids,...value];
          oldResource.ids = new Set(newValue);
        }
      }else{
        let dataMaster = {master_name: master.path, field: master.field, ids: value};
        this.listMasterApiData.push(dataMaster);
      }
    },

    async getListResourceApiData(job, hash){
      if(Array.isArray(this.categoriesDispatchJobList) && this.categoriesDispatchJobList.length > 0){
        this.categoriesDispatchJobList.filter(category => category && category.item && category.item.length >0).forEach(category => {
          category.item.filter(item => item && item.resourceField && item.resourceField.length > 0).forEach(item => {
            item.resourceField.filter(resource => resource && resource.name && !resource.isDeletedByMainSystem 
              && !resource.name.startsWith(jobSettingProperty.ITEM_COMPANY_MODIFY)).forEach(resource => {
              this.settingListMasterInfoAPI(job, resource.name);
            })
          })
        });
      }
      if(Array.isArray(this.headingDispatchJobSettings) && this.headingDispatchJobSettings.length > 0){
        this.headingDispatchJobSettings.filter(heading => heading && heading.name).forEach(heading => {
          this.settingListMasterInfoAPI(job, heading.name);
        });
      }
      if(Array.isArray(this.bodyDispatchJobSettings) && this.bodyDispatchJobSettings.length > 0){
        this.bodyDispatchJobSettings.filter(bodySetting => bodySetting && bodySetting.name).forEach(bodySetting => {
          this.settingListMasterInfoAPI(job, bodySetting.name);
        });
      }

      await Promise.all([...this.listMasterApiData].map(async (masterApi) => {
        let ids = Array.from(masterApi.ids);
        if(masterApi && ids.length > 0){
          await userService.getDispatchResourceData(masterApi.master_name, ids, hash).then(async response => {
            if(response.status === 200){
              let master = this.listMasterApiData.filter(master => master && master.master_name === masterApi.master_name)[0];
              if(master){
                master['data'] = response.data;
              }
            }
          }).catch(e => {
            Utils.responsePageMaintenance(e);
          })
        }
      })).finally(()=>{
        this.isLoadingData = false;
      });
    },

    getDispatchResourceType(key){
      if(!key) return "";
      let keys = key.split('.');
      let item = this.dispatchJobResourceFields[key];
      if(keys.length > 1){
        item = this.dispatchJobResourceFields[keys[0]][keys[1]];
      }
      return item;
    },

    checkHaveMasterData(key){
      let keys = key.split('.');
      if(keys.length > 1){
        let k = this.resourcesAPI.filter(f => f.field === keys[1]);
        return k.length <= 0;
      }else{
        let k = this.resourcesAPI.filter(f => f.field === keys[0]);
        return k.length <= 0;
      }
    },

    getValueFromApiMaster(job, key){
      if(!key || !job) return "";
      let nameResource = key.includes('.')? key.split('.')[1]: key;
      let masterData = this.listMasterApiData.filter(master => master && master.field === nameResource)[0];
      if(!masterData || !masterData.data) return "";
      let value = this.getSubItemValue(job, key);
      if(!value) return "";
      if(Array.isArray(value)){
        let datas = masterData.data.filter(data => value.includes(data.id));
        let itemValues = [];
        datas.forEach(d => {
          itemValues.push(d.name);
        });
        return itemValues.join();
      }else{
        let data = masterData.data.filter(data => data.id === value)[0];
        return data && data.name ? data.name : "";
      }
    },

    async getDataJobOrDispatchJobDetail(jobIds, flag, hash){
      if(!jobIds || !Array.isArray(jobIds) || jobIds.length <= 0) return;
      if(flag){
        await userService.getDispatchResourceData('dispatch-jobs', jobIds, hash).then(response => {
          if (response.status === 200 && response.data) {
            this.dispatchJobDetails = response.data;
            this.dispatchJobDetails.filter((job) => job && job.id).forEach((job) => {
              job["flag"] = true;
            });
          }
        }).catch(e => {
          Utils.responsePageMaintenance(e);
        })
        await Promise.all([...this.dispatchJobDetails].map(async (job) => {
          await this.getListResourceApiData(job, hash);
        }));
      }else{
        await userService.getJobDetails(jobIds, hash).then(response => {
          if (response.status === 200 && response.data) {
            this.prelusionJobDetails = response.data;
            this.prelusionJobDetails.filter((job) => job && job.id).forEach((job) => {
              job["flag"] = false;
            });
          }
        }).catch(e => {
          Utils.responsePageMaintenance(e);
        })
      }
    },

    async viewDetailJob(jobId, type) {
      await this.$emit("createLogger", "Search job page user - Click button " + (this.button.listBtn ? this.button.listBtn : searchJobLabelsProperty.VIEW_DETAIL_JOB) + " with id: " + jobId);
      let urlJobDetail = `${window.location.origin}?c=${encodeURIComponent(this.encryptJobCode)}&jid=${jobId}&query=${encodeURIComponent(this.keyRedisSearch)}&jt=${type}`;
      if(this.jobNewWindow){
        window.open(urlJobDetail);
      }else{
        window.location = urlJobDetail;
        this.onTopOfIframe();
      }
    },

    async previousPage() {
      await this.$emit("createLogger", "Search job page user - Click button " + searchJobLabelsProperty.BUTTON_BACK_PAGE);
      this.page--;
      this.toJob = this.maxResultJobDisplay * this.page;
      this.fromJob = this.maxResultJobDisplay * (this.page - 1);
      this.jobViewDetails = this.paginate(this.jobDetails);
      await this.getResourceApiData(this.hash);
      this.fromJob++;
      this.resetHeightIframe();
      this.onTopOfIframe();
      this.onTopPage();
    },

    onTopPage(){
      document.body.scrollTop = 0;
      let idTopPage = document.getElementById("resize_iframe");
      if(!idTopPage) return;
      idTopPage.scrollIntoView();
    },

    async nextPage() {
      this.isLoadingData = true;
      await this.$emit("createLogger", "Search job page user - Click button " + searchJobLabelsProperty.BUTTON_NEXT_PAGE);
      this.fromJob = (this.maxResultJobDisplay * this.page) + 1;
      this.page++;
      this.toJob = this.maxResultJobDisplay * this.page;
      this.jobViewDetails = this.paginate(this.jobDetails);
      let isUpdateJobDetail = false;
      let isHasNewIdJob = false;
      let isHasNewIdDispatchJob = false;
      if(this.jobViewDetails.length < this.maxResultJobDisplay){
        isUpdateJobDetail = true;
        if(this.isSettingViewJob && this.isHasPropertySearchJob){
          if (this.page > 1) this.pagePrelusion++;
          this.fromPrelusionJob = NUMBER_OF_MAX_JOB_SEARCH * (this.pagePrelusion > 1 ? (this.pagePrelusion - 1) : this.pagePrelusion);
          let ids = Array.from(this.idPrelusionJobs).splice(this.fromPrelusionJob, NUMBER_OF_MAX_JOB_SEARCH);
          if(this.searchJobDto.page < this.lastPrelusionPage && ids.length < NUMBER_OF_MAX_JOB_SEARCH && this.idPrelusionJobs.length < this.totalResultSearchPrelusionJob){
            this.searchJobDto.page += 1;
            let oldPrelusionIds = ids;
            await userService.searchJobFromMatchingood2nd(this.searchJobDto, this.hash).then(response => {
              if (response && response.status === 200) {
                this.lastPrelusionPage = response.data.lastPage;
                this.idPrelusionJobs = oldPrelusionIds.contat(response.data.items);
                this.totalResultSearchPrelusionJob = oldPrelusionIds.length + response.data.total;
                this.setJobSearchPages(false);
                isHasNewIdJob = true;
              }
            }).catch(e => {
              Vue.$toast.clear();
              Vue.$toast.error(messageProperties.ERROR_SEARCH_JOB, {
                position: "bottom-right",
                duration: 3000,
              });
              this.isLoadingData = false;
              Utils.responsePageMaintenance(e);
            })
          }
          ids = Array.from(this.idPrelusionJobs).splice(this.fromPrelusionJob, NUMBER_OF_MAX_JOB_SEARCH);
          await this.getJobDetails(ids, this.hash);
        }

        if(this.isSettingViewDispatchJob && this.isHasPropertySearchDispatch){
          if (this.page > 1) this.pageDispatch++;
          this.fromDispatchJob = NUMBER_OF_MAX_JOB_SEARCH * (this.pageDispatch > 1 ? (this.pageDispatch - 1) : this.pageDispatch);
          let ids = Array.from(this.idDispatchJobs).splice(this.fromDispatchJob, NUMBER_OF_MAX_JOB_SEARCH);
          if(this.searchDispatchJobDto.page < this.lastDispatchPage && ids.length < this.NUMBER_OF_MAX_JOB_SEARCH && this.idDispatchJobs.length < this.totalResultSearchDispatchJob){
            this.searchDispatchJobDto.page += 1;
            let oldDispatchIds = ids;
            await userService.searchDispatchJobFromMatchingood2nd(this.searchDispatchJobDto, this.hash).then(response => {
              if (response && response.status === 200) {
                this.lastDispatchPage = response.data.lastPage;
                this.idDispatchJobs = oldDispatchIds.concat(response.data.items);
                this.totalResultSearchDispatchJob= oldDispatchIds.length + response.data.total;
                this.setJobSearchPages(true);
                isHasNewIdDispatchJob = true;
              }
            }).catch(e => {
              Vue.$toast.clear();
              Vue.$toast.error(messageProperties.ERROR_SEARCH_JOB, {
                position: "bottom-right",
                duration: 3000,
              });
              this.isLoadingData = false;
              Utils.responsePageMaintenance(e);
            })
          }
          ids = Array.from(this.idDispatchJobs).splice(this.fromDispatchJob, NUMBER_OF_MAX_JOB_SEARCH);
          await this.getDispatchJobDetails(ids, this.hash);
        }

        if(isUpdateJobDetail && this.idJobs.length > this.jobDetails.length){
          let nextJobDetails = [];
          if(isHasNewIdJob){
            this.idJobs = this.idJobs.concat(this.idPrelusionJobs);
          }
          if(this.prelusionJobDetails.length > 0) nextJobDetails = nextJobDetails.concat(this.prelusionJobDetails);
          if(isHasNewIdDispatchJob){
            this.idJobs = this.idJobs.concat(this.idDispatchJobs);
          }
          if(this.dispatchJobDetails.length > 0) nextJobDetails = nextJobDetails.concat(this.dispatchJobDetails);

          if(nextJobDetails.length > 0) nextJobDetails = nextJobDetails.sort((a, b) => (moment(a.updated_at).isBefore(b.updated_at) || (moment(a.updated_at).isSame(b.updated_at) && a.id < b.id )) ? 1: -1);

          let oldJobDetail = this.jobDetails;
          for (let index = 0; index < nextJobDetails.length; index++) {
            const oldJob = oldJobDetail.filter(job => job.flag === nextJobDetails[index].flag && job.id === nextJobDetails[index].id)[0];
            if(oldJob){
              continue;
            }
            this.jobDetails.push(nextJobDetails[index]);
          }
          this.jobViewDetails = this.paginate(this.jobDetails);
        }

        this.toJob = this.toJob > this.totalResultSearchJob ? this.totalResultSearchJob : this.toJob;
      }
      await this.getResourceApiData(this.hash);
      this.isLoadingData = false;
      this.resetHeightIframe();
      this.onTopOfIframe();
    },

    setPages() {
      this.page = 1;
      this.fromJob = 1;
      let numberOfPages = Math.ceil(this.totalResultSearchJob / this.maxResultJobDisplay);
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },

    setJobSearchPages(isSearchJob) {
      if(isSearchJob){
        this.pageDispatch = 1;
        this.fromDispatchJob = 1;
        let numberOfPages = Math.ceil(this.totalResultSearchDispatchJob / NUMBER_OF_MAX_JOB_SEARCH);
        for (let index = 1; index <= numberOfPages; index++) {
          this.pagesDispatch.push(index);
        }
      }else{
        this.pagePrelusion = 1;
        this.fromPrelusionJob = 1;
        let numberOfPages = Math.ceil(this.totalResultSearchPrelusionJob / NUMBER_OF_MAX_JOB_SEARCH);
        for (let index = 1; index <= numberOfPages; index++) {
          this.pagesPrelusion.push(index);
        }
      }
    },

    paginate(jobDetails) {
      return jobDetails.slice(this.page*this.maxResultJobDisplay - this.maxResultJobDisplay, this.page*this.maxResultJobDisplay);
    },

    getSingleSelectValue(key, value) {
      let itemValue = "";
      if (!key || !value) {
        return "";
      }

      if (!this.masters[key] || !this.masters[key].items || !this.masters.length <= 0) {
        return "";
      }
      if(Array.isArray(value)){
        let itemValues = [];
        this.masters[key].items.filter(item => value.includes(item.choiceId)).forEach(item => {
          if (item.choiceDisplayName) {
            itemValues.push(item.choiceDisplayName);
          } else {
            itemValues.push(item.choiceName);
          }
        });
        return itemValues.join();
      }else{
        let item = this.masters[key].items.find(item => item.choiceId === value);
        if (item) {
          itemValue = item.choiceDisplayName ? item.choiceDisplayName: item.choiceName;
        }

        return itemValue;
      }
    },

    getMultiSelectValue(key, values) {
      let itemValues = [];
      if (!key || !values || values.length === 0) {
        itemValues.push("");
        return itemValues;
      }

      if (this.masters.length <= 0 || !this.masters[key] || !this.masters[key].items) {
        itemValues.push("");
        return itemValues;
      }

      this.masters[key].items.filter(item => values.includes(item.choiceId)).forEach(item => {
        if (item.choiceDisplayName) {
          itemValues.push(item.choiceDisplayName);
        } else {
          itemValues.push(item.choiceName);
        }
      });

      return itemValues;
    },

    async getCompanies(companyIds, hash) {
      this.isLoadingData = true;
      if (!companyIds || companyIds.length <= 0) {
        this.isLoadingData = false;
        return;
      }

      await userService.getCompanies(companyIds, hash).then(response => {
        if (response.status === 200 && Array.isArray(response.data)) {
          response.data.forEach((newCompany) =>{
            this.companies.push(newCompany);
          });
        }
      }).catch(e => {
        Utils.responsePageMaintenance(e);
      }).finally(() => {
        this.isLoadingData = false;
      })
    },

    async getStaffs(staffIds, hash) {
      this.isLoadingData = true;
      if (!staffIds || staffIds.length <= 0) {
        this.isLoadingData = false;
        return;
      }

      await userService.getStaffs(staffIds, hash).then(response => {
        if (response.status === 200 && Array.isArray(response.data)) {
          response.data.forEach((newStaff) =>{
            this.staffs.push(newStaff);
          });
        }
      }).catch(e => {
        Utils.responsePageMaintenance(e);
      }).finally(() => {
        this.isLoadingData = false;
      })
    },

    getCompanyNameByCompanyId(companyId) {
      if (this.companies.find((com) => com.id === companyId)) {
        return this.companies.find((com) => com.id === companyId).name;
      }
    },

    getCompanyByCompanyId(companyId) {
      let companyData = this.companies.find((com) => com.id === companyId);
      return companyData? companyData: {};
    },

    getStaffNameByStaffId(staffId) {
      let staffData = this.staffs.find((staff) => staff.id === staffId);
      return staffData && staffData.name? staffData.name: "";
    },

    async getJobResourceFields(hash) {
      let searchDto = {};
      searchDto.keyWord = "";
      Vue.$toast.clear();
      await jobSettingService.getJobResourceField(searchDto, hash).then(response => {
        if (response && response.data != null) {
          this.jobResourceFields = response.data;
        }
      }).catch(e => {
        Utils.responsePageMaintenance(e);
      });
    },

    async getDispatchJobResourceFields(hash) {
      let searchDto = {};
      searchDto.keyWord = "";
      Vue.$toast.clear();
      await jobSettingService.getDispatchJobResourceField(searchDto, hash).then(response => {
        if (response && response.data != null) {
          this.dispatchJobResourceFields = response.data;
        }
      }).catch(e => {
        console.log(e);
      });
    },

    isEmptyCategory(cIndex, jIndex, flag) {
      let categories = !flag ? this.categoriesJobList: this.categoriesDispatchJobList;
      let publicSetting = !flag ? this.companyPublicSetting: this.companyDispatchPublicSetting;

      if (categories[cIndex].item.length === 0) {
        return true;
      }

      return categories[cIndex].item.filter(item => {
        let job = this.jobDetails[jIndex];
        let isItemCompany = item.resourceField[0].name.startsWith(jobSettingProperty.ITEM_COMPANY_MODIFY);
        let isPublicCompany = job[publicSetting] === 1;
        let isItemCompanyId = item.resourceField[0].name === 'company_id';
        let isHasCompanyData = (( isItemCompanyId && isPublicCompany) && this.getCompanyNameByCompanyId(job.company_id) || !isItemCompanyId);
        let itemValue = this.getSubItemValue(job, item.resourceField[0].name);
        let itemDeleted = item.resourceField[0].isDeletedByMainSystem;
        return (!itemDeleted && !isItemCompany && itemValue && isHasCompanyData)
        || (!itemDeleted && isItemCompany && this.getCompanyByCompanyId(job.company_id)[item.resourceField[0].name.substring(8)] && isPublicCompany);
      }).length === 0;
    },

    isEmptyCategoryInJobSearch(index) {
      if (this.categoriesJobSearch[index].item.length === 0) {
        return true;
      }

      return this.categoriesJobSearch[index].item.filter(item => !item.resourceField[0].isDeletedByMainSystem).length === 0;
    },

    getPageStatus() {
      authService.getScreenStatus().then(screenStatusResponse => {
        if (Number(screenStatusResponse.data.is_iframe_application_job) !== 1) {
          this.$router.push("/404");
        }
      }).catch(e => {
        Utils.responsePageMaintenance(e);
      });
    },

    printPage() {
      this.$emit("printPage");
    }
  },
};
</script>

<style scoped>
.jobs_search_setting {
  display: flex !important;
}

.pre-margin-bottom {
  margin-bottom: 0 !important;
}

.overlay_setting {
  background-color: rgba(223, 222, 222, 0.6) !important;
}

.line_break_setting_text {
  word-break: break-all;
  white-space: pre-wrap;
}

.setting_word_break {
  word-break: break-all;
}

.white-space {
  white-space: break-spaces;
}

.word-break {
  word-break: break-all;
}

.jobs_page_title_preview {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 15px !important;
}

.jobs_table_annotation_preview {
  margin-top: 8px;
  font-size: 14px;
  margin-bottom: 12px !important;
  white-space: break-spaces;
}
.jobs_page_title{
  margin-bottom: 12px !important;
}

.label_unit_item {
  word-break: keep-all;
}

.label_unit_item_long {
  word-break: break-all !important;
  min-width: 50px;
}
.jobs_result_item{
  margin-top: 1rem;
}

.setting_botton_top{
  position: absolute;
  bottom: calc(100vh/4);
  right: 0.5rem;
  height: 50px;
  padding: 16px;
  display: none;
  z-index: 1;
  font-size: 120%;
  font-weight: bold;
}

.setting_btn_print{
  position: absolute;
  top: 0px;
  right: 0.5rem;
  height: 50px;
  padding: 16px;
  display: block;
  z-index: 1;
  font-size: 120%;
  font-weight: bold;
}
</style>
